export const models = [
  {
    id: "e-vitara",
    category: "nexa",
    name: "Maruti e-Vitara",
    tag: "Spark Your eMagination",
    pic: require("../assets/nexa/e-vitara.webp"),
    price: 1099000,
    fuel: "Electric",
    transmission: "5MT / 6AT",
    cc: "1462",
    variants: [
      {
        variant: "e VITARA",
        price: 1099000,
        mileage: "543 KM",
        seating: "5",
        engine: "",
        fuelType: "Electric",
        transmission: "Automatic",
      },
    ],
    colors: [
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-arctic-white3.png",
      },
      {
        name: "Arctic White with Bluish Black Roof",
        colorCode: "#F9F9F9",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-arctic-white-with-bluish-black-roof.png",
      },
      {
        name: "Bluish Black",
        colorCode: "#181C28",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-bluish-black1.png",
      },
      {
        name: "Grandeur Grey",
        colorCode: "#474848",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-grandeur-grey.png",
      },
      {
        name: "Land Breeze Green with Bluish Black Roof",
        colorCode: "#4B4B3F",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-land-breeze-green-with-bluish-black-roof.png",
      },
      {
        name: "Nexa Blue",
        colorCode: "#1E2B71",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-nexa-blue.png",
      },
      {
        name: "Opulent Red",
        colorCode: "#AC0F0F",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-opulent-red.png",
      },
      {
        name: "Opulent Red with Bluish Black Roof",
        colorCode: "#AC0F0F",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-opulent-red-with-bluish-black-roof.png",
      },
      {
        name: "Splendid Silver Red with Bluish Black Roof",
        colorCode: "#B6BABD",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-splendid-silver-with-bluish-black-roof.png",
      },
      {
        name: "Splendid Silver",
        colorCode: "#B6BABD",
        img: "https://www.varunmaruti.com/uploads/products/colors/e-vitara-splendid-silver.png",
      },
    ],
    banners: [
      {
        img: require("../assets/e-vitara/1.png"),
      },
      {
        img: require("../assets/e-vitara/2.png"),
      },
      {
        img: require("../assets/e-vitara/3.png"),
      },
      {
        img: require("../assets/e-vitara/4.png"),
      },
      {
        img: require("../assets/e-vitara/5.png"),
      },
      {
        img: require("../assets/e-vitara/6.png"),
      },
      {
        img: require("../assets/e-vitara/7.png"),
      },
    ],

    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 4345,
      },
      {
        title: "Width (mm)",
        value: 1795,
      },
      {
        title: "Height (mm)",
        value: 1645,
      },
      {
        title: "Fuel Tank(L)",
        value: 45,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1462,
      },
      {
        title: "Engine Type",
        value: "-",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "75.8kw@6000",
      },
      {
        title: "Max Torque",
        value: "136.8@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT / e-CVT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilated Disc",
      },
      {
        title: "Rear",
        value: "Solid Disc",
      },
      {
        title: "Kerb",
        value: "1150-1185(MT)",
      },
      {
        title: "Gross Weight",
        value: 1410,
      },
    ],
  },

  //invicto
  {
    id: "invicto",
    category: "nexa",
    name: "Maruti Invicto",
    tag: "Created to Inspire the Extraordinary",
    metaTitle:
      "Nexa Invicto Price in Hyderabad | Maruti Invicto 6 Seater Offers Hyderabad",
    metaDescription:
      "Nexa Invocto On road Price in Hyderabad. Maruti Suzuki Invicto Offers. For more details about Invicto features, specifications, mileage, colors and images visit our site or call now.",
    pic: require("../assets/nexa/invicto.webp"),
    brochure: require("../assets/brochures/nexa/invicto.pdf"),
    price: 2497000,
    fuel: "Petrol / Hybrid",
    transmission: "e-CVT",
    cc: "1987",
    variants: [
      {
        variant: "Zeta Plus 7S",
        fuelType: "Strong Hybrid",
        seating: 7,
        engine: "1987 cc",
        transmission: "automatic",
        mileage: 22.16, // km/l
        price: 2497400, // ₹ 24,97,400
        features: [
          "2nd Row Captain Seats with Walk-in Slide & Recline",
          "Roof Mounted 2nd & 3rd Row AC Vent",
          "Drive Mode Selection Switch (Eco/Normal/Power)",
        ],
      },
      {
        variant: "Zeta Plus 8S",
        fuelType: "Strong Hybrid",
        engine: "1987 cc",
        seating: 7,
        transmission: "automatic",
        mileage: 22.16, // km/l
        price: 2502300, // ₹ 25,02,300
        features: [
          "2nd Row 60:40 Split with Walk-in Slide & Recline",
          "Roof Mounted 2nd & 3rd Row AC Vent",
          "Drive Mode Selection Switch (Eco/Normal/Power)",
        ],
      },
      {
        variant: "Alpha Plus 7S",
        fuelType: "Strong Hybrid",
        engine: "1987 cc",
        seating: 7,
        transmission: "automatic",
        mileage: 22.16, // km/l
        price: 2860500, // ₹ 28,60,500
        features: [
          "Panoramic Sunroof with Ambient Lights",
          "360 View Camera with Dynamic Guide Lines",
          "Ventilated Front Seats",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/invicto/1.webp"),
      },
      {
        img: require("../assets/invicto/2.webp"),
      },
      {
        img: require("../assets/invicto/3.webp"),
      },
      {
        img: require("../assets/invicto/4.webp"),
      },
      {
        img: require("../assets/invicto/5.webp"),
      },
      {
        img: require("../assets/invicto/6.webp"),
      },
      {
        img: require("../assets/invicto/7.webp"),
      },
    ],
    colors: [
      {
        name: "Magnificent Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/invicto/colors/magnificent-min.png?updatedAt=1765433866484",
      },
      {
        name: "NEXA Blue (Celestial)",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/invicto/colors/nexa-blue-min.png?updatedAt=1765433866256",
      },
      {
        name: "Stellar Bronze",
        colorCode: "#BEB2A6",
        img: "https://ik.imagekit.io/rahul116/invicto/colors/stellar-bonze-min.png?updatedAt=1765433865574",
      },
      {
        name: "Majestic Silver",
        colorCode: "#CDD3E0",
        img: "https://ik.imagekit.io/rahul116/invicto/colors/majestic-silver-min.png?updatedAt=1765433866399",
      },
      {
        name: "Mystic White",
        colorCode: "#E5E4E2",
        img: "https://ik.imagekit.io/rahul116/invicto/colors/mystic-white-min.png?updatedAt=1765433866395",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 4755,
      },
      {
        title: "Width (mm)",
        value: 1845,
      },
      {
        title: "Height (mm)",
        value: 1795,
      },
      {
        title: "Fuel Tank(L)",
        value: 52,
      },
      {
        title: "Seating",
        value: 7,
      },
      {
        title: "Bootspace(L)",
        value: 318,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1987,
      },
      {
        title: "Max Power",
        value: "112kw@6000",
      },
      {
        title: "Fuel Type",
        value: "Petrol / Hybrid",
      },
      {
        title: "Hybrid Motor",
        value: "AC Synchronous Motor",
      },
      {
        title: "Hybrid Max Power",
        value: "83.73kw@4000",
      },
      {
        title: "Transmission",
        value: "e-CVT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilated Disc",
      },
      {
        title: "Rear",
        value: "Solid Disc",
      },
      {
        title: "Kerb",
        value: "1620/1630",
      },
      {
        title: "Gross Weight",
        value: 2300,
      },
    ],
  },

  //fronx
  {
    metaTitle:
      "Nexa Fronx Price in Hyderabad | Maruti Fronx CNG Offers & Discounts",
    metaDescription:
      "Nexa Fronx on road price in Hyderabad. Maruti Fronx CNG On Road price. Maruti Fronx is now available with 1.2litre DualJet, Dual VVT, BS6 engine with Smart Hybrid tech. Visit your nearest Gem Motors showroom for Nexa Fronx offers & discounts. Call now.",
    id: "fronx",
    category: "nexa",
    name: "Maruti Fronx",
    tag: "Created to Inspire Style and Performance",
    pic: require("../assets/nexa/fronx.png"),
    brochure: require("../assets/brochures/nexa/fronx.pdf"),
    price: 685000,
    fuel: "Petrol / CNG",
    transmission: "5MT / 5AMT",
    cc: "1197",
    variants: [
      {
        variant: "Alpha AT",
        price: 1197900, // ₹ 11 97 900/-
        engine: "998 cc",
        fuelType: "Smart Hybrid",
        transmission: "Automatic",
        mileage: 20.01,
        features: [
          "LED Multi-reflector",
          "22.86cm SmartPlay Pro+",
          "6 Airbags",
        ],
      },
      {
        variant: "Zeta AT",
        price: 1098900, // ₹ 10 98 900/-
        engine: "998 cc",
        fuelType: "Smart Hybrid",
        transmission: "Automatic",
        mileage: 20.01,
        features: ["LED Multi-reflector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Alpha MT",
        price: 1069900, // ₹ 10 69 900/-
        engine: "998 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 21.5,
        features: [
          "LED Multi-reflector",
          "22.86cm SmartPlay Pro+",
          "6 Airbags",
        ],
      },
      {
        variant: "Zeta MT",
        price: 970900, // ₹ 9 70 900/-
        engine: "998 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 21.5, // km/l
        features: ["LED Multi-reflector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Delta Plus DiTC",
        price: 891900, // ₹ 8 91 900/-
        engine: "998 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 21.5, // km/l
        features: ["LED Multi-reflector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Delta CNG",
        price: 858900, // ₹ 8 58 900/-
        engine: "1197 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 28.51, // km/kg
        features: ["Halogen Projector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Delta Plus AGS",
        price: 854500, // ₹ 8 54 500/-
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 22.89, // km/l
        features: [
          "LED Multi-reflector Headlamps",
          "17.78cm SmartPlay Pro",
          "6 Airbags",
        ],
      },
      {
        variant: "Delta AGS",
        price: 814900, // ₹ 8 14 900/-
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 22.89, // km/l
        features: ["Halogen Projector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Delta Plus",
        price: 804500, // ₹ 8 04 500/-
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.79, // km/l
        features: [
          "LED Multi-reflector",
          "17.78cm (SmartPlay Pro)",
          "6 Airbags",
        ],
      },
      {
        variant: "Sigma CNG",
        price: 778900, // ₹ 7 78 900/-
        engine: "1197 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 28.51, // km/kg
        features: ["Halogen Projector", "Hill Hold Assist", "6 Airbags"],
      },
      {
        variant: "Delta MT",
        price: 764900, // ₹ 7 64 900/-
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.79, // km/l
        features: ["Halogen Projector", "17.78cm SmartPlay Pro", "6 Airbags"],
      },
      {
        variant: "Sigma MT",
        price: 684900, // ₹ 6 84 900/-
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.79, // km/l
        features: ["Halogen Projector", "Hill Hold Assist", "6 Airbags"],
      },
    ],
    banners: [
      {
        img: require("../assets/fronx/1.webp"),
      },
      {
        img: require("../assets/fronx/2.webp"),
      },
      {
        img: require("../assets/fronx/3.webp"),
      },
      {
        img: require("../assets/fronx/4.webp"),
      },
      {
        img: require("../assets/fronx/5.webp"),
      },
    ],
    colors: [
      {
        name: "NEXA Blue (Celestial)",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/nexa-blue-min.png?updatedAt=1765436165935",
      },
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/arctic-white-min.png?updatedAt=1765436167060",
      },
      {
        name: "Splendid Silver",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/splendid-silver-min.png?updatedAt=1765436167031",
      },
      {
        name: "Grandeur Grey",
        colorCode: "#464848",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/grandeur-grey-min.png?updatedAt=1765436166997",
      },
      {
        name: "Earthen Brown",
        colorCode: "#95897B",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/easthen-brown-min.png?updatedAt=1765436165214",
      },
      {
        name: "Opulent Red",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/opulent-red-min.png?updatedAt=1765436166959",
      },
      {
        name: "Bluish Black",
        colorCode: "#171717",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/bluish-black-min.png?updatedAt=1765436165729",
      },
      {
        name: "Earthen Brown with Bluish Black Roof",
        colorCode: "#272A39",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/easthen-brown-bluish-black-roof-min.png?updatedAt=1765436165188",
      },
      {
        name: "Splendid Silver with Bluish Black Roof",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/splendid-silver-bluish-black-roof-min.png?updatedAt=1765436166024",
      },
      {
        name: "Opulent Red + Black",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/fronx/colors/opulent-red-black-min.png?updatedAt=1765436166894",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 3995,
      },
      {
        title: "Width (mm)",
        value: 1765,
      },
      {
        title: "Height (mm)",
        value: 1550,
      },
      {
        title: "Fuel Tank(L)",
        value: "37",
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: 308,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1197,
      },
      {
        title: "Engine Type",
        value: "1.2L Dual Jet, Dual VVT",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "66kw@6000",
      },
      {
        title: "Max Torque",
        value: "113@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 5AMT / 6AT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "965-970(MT),975(AMT)",
      },
      {
        title: "Gross Weight",
        value: 1450,
      },
    ],
  },

  //jimny
  {
    metaTitle: "Nexa Jimny Off Road Car Petrol Price & Mileage in Hyderabad",
    metaDescription:
      "Nexa Jimny available in Petrol & CNG Variants. Jimny Off road Price. For More info about Maruti Suzuki Jimny Features, Specifications, Mileage, Colors & Images Call us.",
    id: "jimny",
    category: "nexa",
    name: "Maruti Jimny",
    tag: "Created for Purity of Function",
    pic: require("../assets/nexa/jimny.png"),
    brochure: require("../assets/brochures/nexa/jimny.pdf"),
    price: 1232000,
    fuel: "Petrol",
    transmission: "5MT / 4AT",
    cc: "1462",
    variants: [
      {
        variant: "Alpha PRO AT | Dual Tone",
        price: 1444600, // ₹ 14 44 600/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 16.39,
        seating: 5,
        features: [
          "LED Headlamp Washers",
          "Cruise Control",
          "22.86 cm HD touchscreen",
        ],
      },
      {
        variant: "Alpha PRO | Dual Tone",
        price: 1338600, // ₹ 13 38 600/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 16.94,
        seating: 5,
        features: [
          "LED Headlamp Washers",
          "Cruise Control",
          "22.86 cm HD touchscreen",
        ],
      },
      {
        variant: "Zeta PRO AT",
        price: 1337500, // ₹ 13 37 500/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 16.39,
        seating: 5,
        features: ["Rear View Camera", "6 Airbags", "17.78 cm HD touchscreen"],
      },
      {
        variant: "Zeta PRO",
        price: 1231500, // ₹ 12 31 500/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 16.94,
        seating: 5,
        features: ["Rear View Camera", "6 Airbags", "17.78 cm HD touchscreen"],
      },
    ],
    banners: [
      {
        img: require("../assets/jimny/1.webp"),
      },
      {
        img: require("../assets/jimny/2.webp"),
      },
      {
        img: require("../assets/jimny/3.webp"),
      },
      {
        img: require("../assets/jimny/4.webp"),
      },
      {
        img: require("../assets/jimny/5.webp"),
      },
      {
        img: require("../assets/jimny/6.webp"),
      },
      {
        img: require("../assets/jimny/7.webp"),
      },
    ],

    colors: [
      {
        name: "NEXA Blue ",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/jimny/colors/nex-blue-min.png?updatedAt=1765434163172",
      },
      {
        name: "Pearl Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/jimny/colors/pearl-white-min.png?updatedAt=1765434161391",
      },
      {
        name: "Sizzling Red",
        colorCode: "#B21511",
        img: "https://ik.imagekit.io/rahul116/jimny/colors/sizzling-red-min.png?updatedAt=1765434163227",
      },
      {
        name: "Sizzling Red + Blusish Black",
        colorCode: "#B21511",
        img: "https://ik.imagekit.io/rahul116/jimny/colors/sizzling-red-bluish-black-roof-min.png?updatedAt=1765434163041",
      },
      {
        name: "Blusish Black",
        colorCode: "#95897B",
        img: "https://ik.imagekit.io/rahul116/jimny/colors/bluish-black-min.png?updatedAt=1765434162841",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 3985,
      },
      {
        title: "Width (mm)",
        value: 1645,
      },
      {
        title: "Height (mm)",
        value: 1720,
      },
      {
        title: "Fuel Tank(L)",
        value: "37",
      },
      {
        title: "Seating",
        value: 4,
      },
      {
        title: "Bootspace(L)",
        value: 219,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1462,
      },
      {
        title: "Engine Type",
        value: "K15B with Idle Start Stop",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "77.1kw@6000",
      },
      {
        title: "Max Torque",
        value: "134.2@4000",
      },
      {
        title: "Transmission",
        value: "5MT / 4AT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "1195-1210",
      },
      {
        title: "Gross Weight",
        value: 1545,
      },
    ],
  },

  //grand vitara
  {
    metaTitle:
      "Nexa Grand Vitara Petrol Price & Mileage in Hyderabad |Grand Vitara CNG Price",
    metaDescription:
      "Nexa Grand Vitara available in Petrol & CNG Variants. Grand Vitara Price. For More info about Maruti Suzuki Grand Vitara Features, Specifications, Mileage, Colors & Images Call us.",
    id: "grandvitara",
    category: "nexa",
    name: "Maruti Grand Vitara",
    tag: "Create. Inspire",
    pic: require("../assets/nexa/grandvitara.webp"),
    brochure: require("../assets/brochures/nexa/grand-vitara.pdf"),
    price: 1076500,
    fuel: "Petrol",
    transmission: "5MT / 6AT",
    cc: "1462",
    variants: [
      {
        variant: "Alpha+(O) ",
        price: 1972400, // ₹ 19 72 400/-
        engine: "1490 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.97,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "R17 Machined Alloys",
          "Head Up Display",
        ],
      },
      {
        variant: "Alpha+ ",
        price: 1965600, // ₹ 19 65 600/-
        engine: "1490 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.97,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "R17 Machined Alloys",
          "Head Up Display",
        ],
      },
      {
        variant: "Alpha(O) ALLGRIP ",
        price: 1873000, // ₹ 18 73 000/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 19.2,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Drive Mode Selector",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Zeta+(O) ",
        price: 1865700, // ₹ 18 65 700/-
        engine: "1490 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.97,
        seating: 5,
        features: [
          "EV mode",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Alpha ALLGRIP ",
        price: 1815100, // ₹ 18 15 100/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 19.2,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Drive Mode Selector",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Zeta+ ",
        price: 1807000, // ₹ 18 07 000/-
        engine: "1490 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.97,
        seating: 5,
        features: [
          "EV mode",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Alpha(O) AT | Dual Tone",
        price: 1728000, // ₹ 17 28 000/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.58,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Electronic Parking Brake",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Alpha AT | Dual Tone",
        price: 1670100, // ₹ 16 70 100/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.58,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Electronic Parking Brake",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Delta+",
        price: 1663300, // ₹ 16 63 300/-
        engine: "1490 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.97,
        seating: 5,
        features: [
          "EV mode",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Alpha(O) | Dual Tone",
        price: 1593000, // ₹ 15 93 000/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Bordeaux Leatherette Seats",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Zeta(O) AT | Dual Tone",
        price: 1578400, // ₹ 15 78 400/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.58,
        seating: 5,
        features: [
          "Electronic Parking Brake",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Alpha MT | Dual Tone",
        price: 1535100, // ₹ 15 35 100/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: [
          "8-Way Driver Powered Seat",
          "Bordeaux Leatherette Seats",
          "R17 Machined Alloys",
        ],
      },
      {
        variant: "Zeta AT | Dual Tone",
        price: 1520400, // ₹ 15 20 400/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.58,
        seating: 5,
        features: [
          "Electronic Parking Brake",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Zeta MT CNG | Dual Tone",
        price: 1475400, // ₹ 14 75 400/-
        engine: "1462 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 26.6,
        seating: 5,
        features: [
          "Fuel Change Over Switch with Illumination",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Zeta(O) | Dual Tone",
        price: 1443400, // ₹ 14 43 400/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: [
          "Auto Headlamps",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Zeta MT ",
        price: 1385400, // ₹ 13 85 400/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: [
          "Auto Headlamps",
          "Auto Purify with PM 2.5 Display",
          "Front Ventilated Seats",
        ],
      },
      {
        variant: "Delta AT",
        price: 1344700, // ₹ 13 44 700/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.58,
        seating: 5,
        features: [
          "Electronic Parking Brake",
          "Paddle Shifters",
          "Tyre Pressure Monitoring System",
        ],
      },
      {
        variant: "Delta MT CNG",
        price: 1299700, // ₹ 12 99 700/-
        engine: "1462 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 26.6,
        seating: 5,
        features: [
          "Smartplay Pro",
          "Suzuki Connect",
          "Tyre Pressure Monitoring System",
        ],
      },
      {
        variant: "Delta MT",
        price: 1209700, // ₹ 12 09 700/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: [
          "Smartplay Pro",
          "Suzuki Connect",
          "Tyre Pressure Monitoring System",
        ],
      },
      {
        variant: "Sigma MT",
        price: 1076500, // ₹ 10 76 500/-
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 21.11,
        seating: 5,
        features: ["6 Airbags", "Rear Parking Sensors", "Hill Hold Assist"],
      },
    ],
    banners: [
      {
        img: require("../assets/vitara/1.webp"),
      },
    ],

    colors: [
      {
        name: "NEXA Blue ",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/nexa-blue-min.png?updatedAt=1765435167482",
      },
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/arctic-white-min.png?updatedAt=1765435166952",
      },
      {
        name: "Splendid Silver",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/splendid-silver-min.png?updatedAt=1765435167529",
      },
      {
        name: "Grandeur Grey",
        colorCode: "#464848",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/grandeur-grey-min.png?updatedAt=1765435167353",
      },
      {
        name: "Chestnut Brown",
        colorCode: "#35312E",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/chestnut-brown-min.png?updatedAt=1765435166941",
      },
      {
        name: "Opulent Red",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/opulent-red-min.png?updatedAt=1765435167517",
      },
      {
        name: "Midnight Black",
        colorCode: "#171717",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/midni8-black-min.png?updatedAt=1765435167354",
      },
      {
        name: "Arctic White+Black",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/arctic-white-black-min.png?updatedAt=1765435167464",
      },
      {
        name: "Splendid Silver+Black ",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/splended-silver-black-min.png?updatedAt=1765435167483",
      },
      {
        name: "Opulent Red+Black ",
        colorCode: "#B21511",
        img: "https://ik.imagekit.io/rahul116/grand-vitara/colors/opulent-red-black-min.png?updatedAt=1765435167275",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 4345,
      },
      {
        title: "Width (mm)",
        value: 1795,
      },
      {
        title: "Height (mm)",
        value: 1645,
      },
      {
        title: "Fuel Tank(L)",
        value: 45,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1462,
      },
      {
        title: "Engine Type",
        value: "1.5 L K15C Mild Hybrid Petrol",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "75.8kw@6000",
      },
      {
        title: "Max Torque",
        value: "136.8@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT / e-CVT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilated Disc",
      },
      {
        title: "Rear",
        value: "Solid Disc",
      },
      {
        title: "Kerb",
        value: "1150-1185(MT)",
      },
      {
        title: "Gross Weight",
        value: 1410,
      },
    ],
  },

  //baleno
  {
    metaTitle:
      "Nexa Baleno Price in Hyderabad | Maruti Baleno CNG Offers & Discounts",
    metaDescription:
      "Nexa Baleno  on road price in Hyderabad. Maruti Baleno CNG On Road price. Maruti Baleno is now available with 1.2litre DualJet, Dual VVT, BS6 engine with Smart Hybrid tech. Visit your nearest Gem Motors showroom for Nexa Baleno offers & discounts. Call now.",
    id: "baleno",
    category: "nexa",
    name: "Maruti Baleno",
    tag: "Created to Inspire The Bold and Intelligent",
    pic: require("../assets/nexa/baleno.png"),
    brochure: require("../assets/brochures/nexa/baleno.pdf"),
    price: 599000,
    fuel: "Petrol",
    transmission: "5MT / 5AMT",
    cc: "1197",
    variants: [
      {
        variant: "Alpha AGS",
        fuelType: "petrol",
        engine: "1197 cc",
        transmission: "automatic",
        seating: 5,
        mileage: 22.94, // km/l
        price: 909900, // ₹ 9,09,900
        topFeatures: ["360 View Camera", "Head Up Display", "6 Airbags"],
      },
      {
        variant: "Alpha MT",
        fuelType: "petrol",
        seating: 5,
        engine: "1197 cc",
        transmission: "manual",
        mileage: 22.35, // km/l
        price: 859900, // ₹ 8,59,900
        topFeatures: ["360 View Camera", "Head Up Display", "6 Airbags"],
      },
      {
        variant: "Zeta AGS",
        fuelType: "petrol",
        seating: 5,
        engine: "1197 cc",
        transmission: "automatic",
        mileage: 22.94, // km/l
        price: 819900, // ₹ 8,19,900
        topFeatures: [
          "6 Airbags",
          "Suzuki Connect",
          "Wireless Phone Connectivity",
        ],
      },
      {
        variant: "Zeta MT",
        fuelType: "petrol",
        seating: 5,
        engine: "1197 cc",
        transmission: "manual",
        mileage: 22.35, // km/l
        price: 769900, // ₹ 7,69,900
        topFeatures: [
          "6 Airbags",
          "Suzuki Connect",
          "Wireless Phone Connectivity",
        ],
      },
      {
        variant: "Delta AGS",
        fuelType: "petrol",
        seating: 5,
        engine: "1197 cc",
        transmission: "automatic",
        mileage: 22.94, // km/l
        price: 729900, // ₹ 7,29,900
        topFeatures: [
          "Steering Mounted Controls",
          "Electrically Foldable & Adjustable ORVMs",
          "6 Airbags",
        ],
      },
      {
        variant: "Delta MT",
        fuelType: "petrol",
        seating: 5,
        engine: "1197 cc",
        transmission: "manual",
        mileage: 22.35, // km/l
        price: 679900, // ₹ 6,79,900
        topFeatures: [
          "Steering Mounted Controls",
          "Electrically Foldable & Adjustable ORVMs",
          "6 Airbags",
        ],
      },
      {
        variant: "Sigma MT",
        fuelType: "petrol",
        engine: "1197 cc",
        seating: 5,
        transmission: "manual",
        mileage: 22.35, // km/l
        price: 598900, // ₹ 5,98,900
        topFeatures: [
          "Halogen Projector Headlamps",
          "Reverse Parking Sensors",
          "6 Airbags",
        ],
      },

      // baleno cng

      {
        variant: "Delta CNG",
        fuelType: "CNG",
        seating: 5,
        engine: "1197 cc",
        transmission: "manual",
        mileage: 30.61, // km/kg
        price: 769900, // ₹ 7,69,900
        topFeatures: [
          "Steering Mounted Controls",
          "Electrically foldable & adjustable ORVMs",
          "60:40 split rear seat",
        ],
      },
      {
        variant: "Zeta CNG MT",
        fuelType: "CNG",
        seating: 5,
        engine: "1197 cc",
        transmission: "manual",
        mileage: 30.61, // km/kg
        price: 859900, // ₹ 8,59,900
        topFeatures: [
          "6 Airbags",
          "Suzuki Connect",
          "Wireless Phone Connectivity",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/baleno/1.webp"),
      },
    ],

    colors: [
      {
        name: "NEXA Blue ",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/nexa-blue-min.png?updatedAt=1765436480054",
      },
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/arctic-white-min.png?updatedAt=1765436480130",
      },
      {
        name: "Splendid Silver",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/splendid-silver-min.png?updatedAt=1765436480046",
      },
      {
        name: "Grandeur Grey",
        colorCode: "#464848",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/grandeur-grey-min.png?updatedAt=1765436479998",
      },

      {
        name: "Opulent Red",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/opulent-red-min.png?updatedAt=1765436480069",
      },

      {
        name: "Luxe-Beige",
        colorCode: "#68482F",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/luxe-beige-min.png?updatedAt=1765436480065",
      },
      {
        name: "Bluish Black",
        colorCode: "#181C28",
        img: "https://ik.imagekit.io/rahul116/baleno/colors/bluish-black-min.png?updatedAt=1765436479253",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 3990,
      },
      {
        title: "Width (mm)",
        value: 1745,
      },
      {
        title: "Height (mm)",
        value: 1500,
      },
      {
        title: "Fuel Tank(L)",
        value: 37,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: 318,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1197,
      },
      {
        title: "Engine Type",
        value: "Adv. K Series Dual Jet / Dual VVT Engine",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "66kw@6000",
      },
      {
        title: "Max Torque",
        value: "113@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 5AMT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "925-955(MT),940-960(AMT)",
      },
      {
        title: "Gross Weight",
        value: 1410,
      },
    ],
  },

  //xl6
  {
    metaTitle:
      "Nexa XL6 Price in Hyderabad | Maruti XL6 6 Seater Offers Hyderabad",
    metaDescription:
      "Nexa XL6 On road Price in Hyderabad. Maruti Suzuki XL6 Offers. For more details about XL6 features, specifications, mileage, colors and images visit our site or call now.",
    id: "xl6",
    category: "nexa",
    name: "Maruti XL6",
    tag: "Created to Inspire the Indulgence.",
    pic: require("../assets/nexa/xl6.webp"),
    brochure: require("../assets/brochures/nexa/xl6.pdf"),
    price: 1152000,
    fuel: "Petrol",
    transmission: "5MT / 6AT",
    cc: "1462",
    variants: [
      {
        variant: "Alpha Plus AT",
        subVariant: "Dual Tone",
        fuelType: "smart-hybrid",
        seating: 7,
        engine: "1462 cc",
        transmission: "automatic",
        mileage: 20.27, // km/l
        price: 1447500, // ₹ 14,47,500
        topFeatures: [
          "Cruise Control",
          "360 View Camera",
          "ESP with Hill Hold",
        ],
      },
      {
        variant: "Alpha AT",
        fuelType: "smart-hybrid",
        engine: "1462 cc",
        seating: 7,
        transmission: "automatic",
        mileage: 20.27, // km/l
        price: 1383800, // ₹ 13,83,800
        topFeatures: [
          "Cruise Control",
          "360 View Camera",
          "ESP with Hill Hold",
        ],
      },
      {
        variant: "Alpha Plus MT",
        subVariant: "Dual Tone",
        fuelType: "smart-hybrid",
        engine: "1462 cc",
        seating: 7,
        transmission: "manual",
        mileage: 20.97, // km/l
        price: 1312500, // ₹ 13,12,500
        topFeatures: [
          "Cruise Control",
          "360 View Camera",
          "ESP with Hill Hold",
        ],
      },
      {
        variant: "Zeta AT",
        fuelType: "smart-hybrid",
        seating: 7,
        engine: "1462 cc",
        transmission: "automatic",
        mileage: 20.27, // km/l
        price: 1287300, // ₹ 12,87,300
        topFeatures: [
          "Cruise Control",
          "17.78 cm SmartPlay Studio Touchscreen Infotainment System",
          "ESP with Hill Hold",
        ],
      },
      {
        variant: "Alpha MT",
        fuelType: "smart-hybrid",
        engine: "1462 cc",
        seating: 7,
        transmission: "manual",
        mileage: 20.97, // km/l
        price: 1248800, // ₹ 12,48,800
        topFeatures: [
          "Cruise Control",
          "360 View Camera",
          "ESP with Hill Hold",
        ],
      },
      {
        variant: "Zeta MT",
        fuelType: "smart-hybrid",
        engine: "1462 cc",
        seating: 7,
        transmission: "manual",
        mileage: 20.97, // km/l
        price: 1152300, // ₹ 11,52,300
        topFeatures: [
          "Cruise Control",
          "17.78 cm SmartPlay Studio Touchscreen Infotainment System",
          "ESP with Hill Hold",
        ],
      },
      // xl6 cng

      {
        variant: "Zeta CNG",
        fuelType: "cng",
        engine: "1462 cc",
        seating: 7,
        transmission: "manual",
        mileage: 26.32, // km/kg
        price: 1243300, // ₹ 12,43,300
        topFeatures: [
          "Cruise Control",
          "17.78 cm SmartPlay Studio Touchscreen Infotainment System",
          "ESP with Hill Hold",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/xl6/1.webp"),
      },
    ],

    colors: [
      {
        name: "NEXA Blue ",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/nexa-blue-min.png?updatedAt=1765434774390",
      },
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/Arctic-white-min.png?updatedAt=1765434774385",
      },
      {
        name: "Splendid Silver",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/splended-silver-black-roof-min.png?updatedAt=1765434774389",
      },
      {
        name: "Splendid Silver + Black Roof",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/splended-silver-black-roof-min.png?updatedAt=1765434774389",
      },
      {
        name: "Grandeur Grey",
        colorCode: "#464848",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/grandeur-grey-min.png?updatedAt=1765434774401",
      },

      {
        name: "Opulent Red",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/opulent-red-midni8-black-roof-min.png?updatedAt=1765434774399",
      },
      {
        name: "Bluish Black",
        colorCode: "#181C28",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/bluish-black-min.png?updatedAt=1765434772650",
      },

      {
        name: "Brave Khaki Midnight-Black-Roof",
        colorCode: "#68482F",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/brave-khaki-midnight-black-roof-min.png?updatedAt=1765434774349",
      },

      {
        name: "Brave Khaki",
        colorCode: "#AC0F0F",
        img: "https://ik.imagekit.io/rahul116/xl6/colors/brave-khaki-min.png?updatedAt=1765434774275",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //should be 6 items or max 6 items
      {
        title: "Length (mm)",
        value: 4445,
      },
      {
        title: "Width (mm)",
        value: 1775,
      },
      {
        title: "Height (mm)",
        value: 1755,
      },
      {
        title: "Fuel Tank(L)",
        value: 45,
      },
      {
        title: "Seating",
        value: 6,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: 1462,
      },
      {
        title: "Engine Type",
        value: "K15C Smart Hybrid",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "75.8kw@6000",
      },
      {
        title: "Max Torque",
        value: "136.8@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "1200 (MT), 1225 (AT)",
      },
      {
        title: "Gross Weight",
        value: "1740(MT), 1765(AT)",
      },
    ],
  },

  //ciaz
  // {
  //   metaTitle:
  //     "Nexa Ciaz Car On Road Price, Mileage, Specifications & Offers | Gem Maruti",
  //   metaDescription:
  //     "Nexa Ciaz Car On road Price, Mileage of 26.8 km/l. Get Nexa Ciaz Specifications & Features. Best Offers on Ciaz Car, Low EMI, Low Down-Payment. Call now.",
  //   id: "ciaz",
  //   category: "nexa",
  //   name: "Maruti Ciaz",
  //   tag: "Created to Inspire Elegance.",
  //   pic: require("../assets/nexa/ciaz.webp"),
  //   brochure: require("../assets/brochures/nexa/ciaz.pdf"),
  //   price: 930000,
  //   fuel: "Petrol",
  //   transmission: "5MT / 4AT",
  //   cc: "1462",
  //   variants: [
  //     {
  //       variant: "SMART HYBRID CIAZ S",
  //       price: 0,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //     {
  //       variant: "SMART HYBRID ALPHA",
  //       price: 11.09,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //     {
  //       variant: "SMART HYBRID ALPHA AT",
  //       price: 12.29,
  //       mileage: "20.04 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "AUTOMATIC",
  //     },
  //     {
  //       variant: "SMART HYBRID DELTA",
  //       price: 9.9,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //     {
  //       variant: "SMART HYBRID DELTA AT",
  //       price: 11.1,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "AUTOMATIC",
  //     },
  //     {
  //       variant: "SMART HYBRID SIGMA",
  //       price: 9.3,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //     {
  //       variant: "SMART HYBRID ZETA",
  //       price: 10.3,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //     {
  //       variant: "SMART HYBRID ZETA AT",
  //       price: 11.5,
  //       mileage: "20.65 kmpl",
  //       seating: "5",
  //       engine: "1462 cc",
  //       fuelType: "PETROL",
  //       transmission: "Manual",
  //     },
  //   ],
  //   banners: [
  //     {
  //       img: require("../assets/ciaz/1.webp"),
  //     },
  //   ],

  //   colors: [
  //     {
  //       name: "NEXA Blue ",
  //       colorCode: "#163472",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/nexa-blue.webp?updatedAt=1765435837864",
  //     },
  //     {
  //       name: "Arctic White",
  //       colorCode: "#F9F9F9",
  //       img: "https://ik.imagekit.io/rahul116/xl6/colors/Arctic-white-min.png?updatedAt=1765434774385",
  //     },
  //     {
  //       name: "Splendid Silver",
  //       colorCode: "#B6BABD",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/splendid-silver.webp?updatedAt=1765435837923",
  //     },

  //     {
  //       name: "Grandeur Grey",
  //       colorCode: "#464848",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/grandeur-grey.webp?updatedAt=1765435837936",
  //     },
  //     {
  //       name: "Grandeur Grey Bluish Black",
  //       colorCode: "#464848",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/grandeur-grey-bluish-black.webp?updatedAt=1765435837812",
  //     },
  //     {
  //       name: "Opulent Red + Bluish Black",
  //       colorCode: "#AC0F0F",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/opulent-red-bluish-black.webp?updatedAt=1765435837859",
  //     },
  //     {
  //       name: "Opulent Red",
  //       colorCode: "#AC0F0F",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/opulent-red.webp?updatedAt=1765435837880",
  //     },
  //     {
  //       name: "Bluish Black",
  //       colorCode: "#181C28",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/bluish-black.webp?updatedAt=1765435837934",
  //     },
  //     {
  //       name: "Pearl Metalic Brown",
  //       colorCode: "#68482F",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/pearl-metalic-brown.webp?updatedAt=1765435837996",
  //     },
  //     {
  //       name: "Pearl Metalic Dignity Brown Aid Bluish Black",
  //       colorCode: "#68482F",
  //       img: "https://ik.imagekit.io/rahul116/ciaz/colors/pearl-metallic-dignity-brown-aid-bluish-black.webp?updatedAt=1765435837901",
  //     },
  //   ],

  //   // dimensions & capacity
  //   dimensions: [
  //     //should be 6 items or max 6 items
  //     {
  //       title: "Length (mm)",
  //       value: 4490,
  //     },
  //     {
  //       title: "Width (mm)",
  //       value: 1730,
  //     },
  //     {
  //       title: "Height (mm)",
  //       value: "-",
  //     },
  //     {
  //       title: "Fuel Tank(L)",
  //       value: 43,
  //     },
  //     {
  //       title: "Seating",
  //       value: 5,
  //     },
  //     {
  //       title: "Bootspace(L)",
  //       value: "-",
  //     },
  //   ],

  //   //engine & transmission
  //   engine: [
  //     {
  //       title: "Capacity(cc)",
  //       value: "-",
  //     },
  //     {
  //       title: "Engine Type",
  //       value: "K15C Smart Hybrid",
  //     },
  //     {
  //       title: "Cylinders",
  //       value: 4,
  //     },
  //     {
  //       title: "Max Power",
  //       value: "77kw@6000",
  //     },
  //     {
  //       title: "Max Torque",
  //       value: "138@4400",
  //     },
  //     {
  //       title: "Transmission",
  //       value: "5MT / 4AT",
  //     },
  //   ],

  //   //weights & brakes
  //   weight: [
  //     {
  //       title: "Front",
  //       value: "Ventialted Disc",
  //     },
  //     {
  //       title: "Rear",
  //       value: "Drum",
  //     },
  //     {
  //       title: "Kerb",
  //       value: "-",
  //     },
  //     {
  //       title: "Gross Weight",
  //       value: "1520 (MT), 1530 (AT)",
  //     },
  //   ],
  // },

  //ignis
  {
    metaTitle: "Nexa Ignis On road Price & Offers in Hyderabad | Gem Motors",
    metaDescription:
      "Get latest offers on Nexa Ignis. Maruti Ignis On road Price, Mileage of 24.3 Km/l & available in 4 variants. Call now for Nexa Ignis Offers.",
    id: "ignis",
    category: "nexa",
    name: "Maruti Ignis",
    tag: "Created to Inspire the Toughness in you.",
    pic: require("../assets/nexa/ignis.webp"),
    brochure: require("../assets/brochures/nexa/ignis.pdf"),
    price: 535000,
    fuel: "Petrol",
    transmission: "5 MT/AMT",
    cc: "1197",
    variants: [
      {
        variant: "Alpha AGS",
        price: 754700, // ₹ 7 54 700/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Automatic",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Hill Hold Assist",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Alpha MT",
        price: 709700, // ₹ 7 09 700/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Manual",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Electronic Stability Program",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Zeta AGS",
        price: 695200, // ₹ 6 95 200/-
        engine: "1197 cc",
        seating: 5,
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Hill Hold Assist",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Zeta MT",
        price: 650200, // ₹ 6 50 200/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Manual",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Electronic Stability Program",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Delta AGS",
        price: 629500, // ₹ 6 29 500/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Automatic",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Hill Hold Assist",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Delta MT",
        price: 584500, // ₹ 5 84 500/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Manual",
        mileage: 20.89, // km/l
        features: [
          "Remote Keyless Entry",
          "Electronic Stability Program",
          "Rear Parking Sensor",
        ],
      },
      {
        variant: "Sigma MT",
        price: 535100, // ₹ 5 35 100/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Manual",
        mileage: 20.89, // km/l
        features: [
          "High-mount LED Stop Lamp",
          "Electronic Stability Program",
          "Rear Parking Sensor",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/ignis/1.webp"),
      },
    ],

    colors: [
      {
        name: "NEXA Blue ",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/nexa-blue-min.png?updatedAt=1765436811064",
      },
      {
        name: "Arctic White",
        colorCode: "#F9F9F9",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/pearl-arctic-white-min.png?updatedAt=1765436813438",
      },
      {
        name: "Silky Silver",
        colorCode: "#B6BABD",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/silky-silver-min.png?updatedAt=1765436813492",
      },

      {
        name: "Gistening Grey",
        colorCode: "#464848",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/gistening-grey-min.png?updatedAt=1765436813492",
      },
      {
        name: "Lucent Orange Black-roof",
        colorCode: "#A12B00",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/lucent-orange-black-roof-min.png?updatedAt=1765436813435",
      },
      {
        name: "Lucent Orange",
        colorCode: "#A12B00",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/lucent-orange-min.png?updatedAt=1765436810445",
      },
      {
        name: "Bluish Black",
        colorCode: "#181C28",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/bluish-black-min.png?updatedAt=1765436813410",
      },
      {
        name: "Nexa Blue Black Roof",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/nexa-blue-black-roof-min.png?updatedAt=1765436810415",
      },

      {
        name: "Nexa Blue Silver Roof",
        colorCode: "#163472",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/nexa-blue-silver-roof-min.png?updatedAt=1765436813164",
      },
      {
        name: "Turquoise Blue",
        colorCode: "#00648F",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/turquoise-blue-min.png?updatedAt=1765436813203",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3700,
      },
      {
        title: "Width (mm)",
        value: 1690,
      },
      {
        title: "Height (mm)",
        value: "1595",
      },
      {
        title: "Fuel Tank(L)",
        value: 32,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: 260,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1197",
      },
      {
        title: "Engine Type",
        value: "VVT",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "61kw@6000",
      },
      {
        title: "Max Torque",
        value: "113@4200",
      },
      {
        title: "Transmission",
        value: "5 MT/AMT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "840-865",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  //victoris
  {
    metaTitle:
      "Maruti Suzuki Victoris On Road Price| Maruti Victoris Offers | Victoris Mileage",
    metaDescription:
      "Maruti Suzuki Victoris on road price in Hyderabad. Visit nearest Gem Maruti Suzuki Showroom to get Offers on Victoris. Maruti Suzuki Alto K10 Mileage. Book A Test Drive",
    id: "victoris",
    category: "arena",
    name: "Maruti Victoris",
    brochure: require("../assets/brochures/arena/victoris.pdf"),
    tag: "Got it all",
    pic: require("../assets/thumbnails/victoris.webp"),
    price: 1049900,
    fuel: "Petrol",
    transmission: "5MT / 6AT/ e-CVT",
    cc: "1462",
    banners: [
      {
        img: require("../assets/victoris/1.png"),
      },
      {
        img: require("../assets/victoris/2.png"),
      },
      {
        img: require("../assets/victoris/3.png"),
      },
      {
        img: require("../assets/victoris/4.png"),
      },
      {
        img: require("../assets/victoris/5.png"),
      },
      {
        img: require("../assets/victoris/6.png"),
      },
    ],
    variants: [
      {
        variant: "Victoris LXI  MT",
        price: 1049900,
        engine: "1462 cc ",
        fuelType: "PETROL",
        transmission: "Manual",
        mileage: 27.02,
        seating: 5,
        features: ["Suzuki Connect", "6 Air bags", "Push start system"],
      },
      //S-CNG
      {
        variant: "Victoris LXI CNG MT",
        price: 1149900,
        engine: "1462 cc ",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 27.02,
        seating: 5,
        features: ["Smart play pro 7 audio", "6 Air bags", "Push start system"],
      },
      {
        variant: "Victoris VXI CNG MT",
        price: 1279900, // ₹11,49,900 ex-showroom
        engine: "1462 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 27.02,
        seating: 5,
        features: ["Suzuki Connect", "TPMS", "Connected tail lamp"],
      },
      {
        variant: "Victoris ZXI CNG MT ",
        price: 1472300, // ₹11,79,900 ex-showroom
        engine: "1462 cc",
        fuelType: "S-CNG ",
        transmission: "Manual",
        mileage: 21.18,
        seating: 5,
        features: ["Suzuki Connect", "TPMS", "Connected tail lamp"],
      },

      //STRONG HYBRID

      {
        variant: "Victoris VXI STRONG HYBRID",
        price: 1637900, // ₹12,79,900 ex-showroom
        engine: "1462 cc",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 27.02,
        seating: 5,
        features: ["Suzuki Connect", "TPMS", "Connected tail lamp"],
      },
      {
        variant: "Victoris ZXI STRONG HYBRID",
        price: 1795300, // ₹13,35,900 ex-showroom
        engine: "1462 cc Smart Hybrid",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: [
          "LED projector headlamps+ DRL",
          "10.25 digital cluster",
          "Smart power tailgate with gesture control",
        ],
      },
      {
        variant: "Victoris ZXI (O) STRONG HYBRID",
        price: 1854300, // ₹13,35,900 ex-showroom
        engine: "1462 cc Smart Hybrid",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: [
          "Panoramic sunroof",
          "10.25 digital cluster",
          "Smart power tailgate with gesture control",
        ],
      },
      {
        variant: "Victoris ZXI STRONG HYBRID",
        price: 1962300, // ₹13,35,900 ex-showroom
        engine: "1462 cc Smart Hybrid",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment",
          "8 speaker infinity sound",
          "64 colour ambient light",
        ],
      },
      {
        variant: "Victoris ZXI+ (O) STRONG HYBRID ",
        price: 1998900,
        engine: "1462 cc Smart Hybrid",
        fuelType: "Strong Hybrid",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment",
          "8 speaker infinity sound",
          "Panoramic sunroof",
        ],
      },

      //Petrol

      {
        variant: "Victoris VXI AT ",
        price: 1335900,
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: ["Suzuki Connect", "TPMS", "Connected tail lamp"],
      },

      {
        variant: "Victoris ZXI AT | Dual Tone",
        price: 1528300,
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 22,
        seating: 5,
        features: [
          "LED projector headlamps + DRL",
          '10.25" digital cluster',
          "Smart power tailgate with gesture control",
        ],
      },
      {
        variant: "Victoris ZXI (O) AT ",
        price: 1579300, // ₹ 15 79 300
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 22, // not shown in image
        seating: 5,
        features: [
          "Panoramic sunroof",
          '10.25" digital cluster',
          "Smart power tailgate with gesture control",
        ],
      },
      {
        variant: "Victoris ZXI+ AT (ADAS)",
        price: 1734300,
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 23,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment",
          "8 speaker infinity sound",
          "64 colour ambient light",
        ],
      },
      {
        variant: "Victoris ZXI+ (O) AT [ADAS]",
        price: 1792300, // ₹ 17 92 300
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 23,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment and 8 speaker infinity sound",
          "ADAS level 2 (AT)",
          "Panoramic sunroof",
        ],
      },
      {
        variant: "Victoris ZXI+ AT ALLGRIP [ADAS] ",
        price: 1879300,
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 23,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment",
          "8 speaker infinity sound",
          "64 colour ambient light",
        ],
      },
      {
        variant: "Victoris ZXI+ (O) AT ALLGRIP [ADAS] ",
        price: 1937300,
        engine: "1462 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 23,
        seating: 5,
        features: [
          "Smart play pro X touch screen infotainment and 8 speaker infinity sound",
          "ADAS level 2 (AT)",
          "Panoramic sunroof",
        ],
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 4360,
      },
      {
        title: "Width (mm)",
        value: 1795,
      },
      {
        title: "Height (mm)",
        value: "1655",
      },
      {
        title: "Fuel Tank(L)",
        value: 45,
      },
      {
        title: "Seating",
        value: 5,
      },
      // {
      //   title: "Bootspace(L)",
      //   value: ,
      // },
    ],
    colors: [
      {
        name: "Eternal Blue with Bluish Black Roof",
        colorCode: "#24475B",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/Eternal_blue_with_bluish_roof-min.png?updatedAt=1762336384588",
      },
      {
        name: "Splendid Silver With Bluish Black Roof",
        colorCode: "#84888D",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/splendid_silver_with_Bluishblackroof-min.png?updatedAt=1762336384450",
      },
      {
        name: "Splendid Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/splendid_silver-min.png?updatedAt=1762336384590",
      },
      {
        name: "Sizzling Red With Bluish Black Roof",
        colorCode: "#991E23",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/sizzling_red_black_roof-min.png?updatedAt=1762336384527",
      },
      {
        name: "Sizzling Red",
        colorCode: "#991E23",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/sizzling_red-min.png?updatedAt=1762336384483",
      },
      {
        name: "Mystic Green",
        colorCode: "#233B47",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/mystic_green-min.png?updatedAt=1762336384471",
      },
      {
        name: "Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/Blusih_Black-min.png?updatedAt=1762336384487",
      },
      {
        name: "Pearl Arctic White",
        colorCode: "#F3F3F3",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/pearl_arctic_white-min.png?updatedAt=1762336384519",
      },
      {
        name: "Magma Grey",
        colorCode: "#2B2C31",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/Magma_Grey-min.png?updatedAt=1762336384579g",
      },
      {
        name: "Eternal Blue",
        colorCode: "#24475B",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Victoris/Colors/enternal_blue-min.png?updatedAt=1762336384579",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1462",
      },
      {
        title: "Engine Type",
        value: "K15C Smart Hybrid",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "75.8kW@6000",
      },
      {
        title: "Max Torque",
        value: "139Nm@4200",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT / e-CVT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Disc",
      },
      {
        title: "Kerb",
        value: "1145-1195(MT), 1185-1225(AT)",
      },
      {
        title: "Gross Weight",
        value: "1655(MT), 1685(AT)",
      },
    ],
  },

  //alto k10
  {
    metaTitle:
      "Maruti Suzuki Alto K10 On Road Price| Maruti Alto K10 Offers | Alto K10 Mileage",
    metaDescription:
      "Maruti Suzuki Alto K10 on road price in Hyderabad. Visit nearest Gem Maruti Suzuki Showroom to get Offers on Alto K10. Maruti Suzuki Alto K10 Mileage. Book A Test Drive",
    id: "alto-k10",
    category: "arena",
    name: "Maruti Alto K10",
    tag: "India ki Chal Padi",
    pic: require("../assets/thumbnails/alto-k10.webp"),
    brochure: require("../assets/brochures/arena/alto-k10.pdf"),
    price: 369000,
    fuel: "Petrol",
    transmission: "5MT / AGS",
    cc: "998",
    variants: [
      //PETROL
      {
        variant: "Alto K10 Std (O) ",
        price: 369900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 24.39,
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Alto K10 LXi (O) MT ",
        price: 399900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 24,
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Alto K10 VXi (O) MT ",
        price: 449900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 24,
        seating: 5,
        features: ["SmartPlay Dock", "ABS with EBD", "Reverse Parking Sensors"],
      }, {
        variant: "Alto K10 LXi (O) CNG ",
        price: 481900,
        engine: "998 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 23,
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Alto K10 VXi (O) AGS ",
        price: 494900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 24,
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Alto K10 VXi+ (O) MT ",
        price: 499900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 24,
        seating: 5,
        features: [
          "17.78 cm (SmartPlay Studio)",
          "6 Airbags",
          "Reverse Parking Sensors",
        ],
      }, {
        variant: "Alto K10 VXi (O) CNG | Metallic",
        price: 531900,
        engine: "998 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 24,
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Alto K10 VXi+ (O) AGS ",
        price: 544900, // ₹ 5 44 900
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: 24.05,
        seating: 5,
        features: [
          "17.78 cm (SmartPlay Studio)",
          "6 Airbags",
          "Reverse Parking Sensors",
        ],
      },


    ],
    banners: [
      {
        img: require("../assets/k10/1.webp"),
      },
      {
        img: require("../assets/k10/2.webp"),
      },
      {
        img: require("../assets/k10/3.webp"),
      },
    ],

    colors: [
      {
        name: "Red",
        colorCode: "#e01111",
        img: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_red.webp",
      },
      {
        name: "Ocean Blue",
        colorCode: "#1d4ed8",
        img: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_blue.webp",
      },
      {
        name: "Steel Grey",
        colorCode: "#9ca3af",
        img: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_grey.webp",
      },
      {
        name: "Pearl White",
        colorCode: "#ffffff",
        img: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_white.webp",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3530,
      },
      {
        title: "Width (mm)",
        value: 1490,
      },
      {
        title: "Height (mm)",
        value: "1520",
      },
      {
        title: "Fuel Tank(L)",
        value: 27,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: 214,
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "998",
      },
      {
        title: "Engine Type",
        value: "K10C",
      },
      {
        title: "Cylinders",
        value: 4,
      },
      {
        title: "Max Power",
        value: "49kw@6000",
      },
      {
        title: "Max Torque",
        value: "89@4200",
      },
      {
        title: "Transmission",
        value: "5MT / AGS",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "-",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  //s-presso
  {
    metaTitle: "Maruti Suzuki Spresso Price Hyderabad | Offers on Spresso",
    metaDescription:
      "Maruti Suuzki Spresso Compatable SUV On Road Price in Hyderabad. Maruti Spresso Offers. Spresso Dpecifications & Features.visit Now.",
    id: "s-presso",
    category: "arena",
    name: "Maruti S.presso",
    tag: "Styled for xtra excitement.",
    pic: require("../assets/thumbnails/spresso.webp"),
    brochure: require("../assets/brochures/arena/spresso.pdf"),
    price: 349900,
    fuel: "Petrol",
    transmission: "5MT / AGS",
    cc: "998",
    variants: [
      //spesso
      {
        variant: "S-Presso Std (O) MT",
        price: 349900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 21.06,
        seating: 5,
        features: ["Dual airbags", "ABS with EDB", "ESP"],
      },
      {
        variant: "S-Presso LXi (O) MT ",
        price: 379900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 21.06,
        seating: 5,
        features: ["Dual airbags", "ABS with EDB", "ESP"],
      },
      {
        variant: "S-Presso VXi (O) MT  ",
        price: 429900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 21.06,
        seating: 5,
        features: ["Dual airbags", "Full Wheel Covers", "Smartplay dock"],
      },
      {
        variant: "S-Presso VXi (O) AGS ",
        price: 474900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "Automatic",
        mileage: 21.06,
        seating: 5,
        features: ["Dual airbags", "Full Wheel Covers", "Hill Hold Assist"],
      },
      {
        variant: "S-Presso VXi+ (O) MT ",
        price: 479900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 21.06,
        seating: 5,
        features: [
          "Dual airbags",
          "Electrically adjustable ORVMs",
          "SmartPlay Studio - 17.78 cm Touch Screen Infotainment System",
        ],
      },
      {
        variant: "S-Presso VXi+ (O) AGS ",
        price: 524900, // ₹13,35,900 ex-showroom
        engine: "998 cc",
        fuelType: "petrol",
        transmission: "automatic",
        mileage: 21.06,
        seating: 5,
        features: [
          "Dual airbags",
          "Electrically adjustable ORVMs",
          "SmartPlay Studio - 17.78 cm Touch Screen Infotainment System",
        ],
      },

      //s-cng
      {
        variant: "S-Presso LXi (O) CNG",
        // price: 0, // ₹ 4,61,900  "23.90"
        engine: "998 cc",
        fuelType: "cng",
        transmission: "manual",
        mileage: 23.9, // add if you have
        seating: 5,
        features: ["Dual Airbags", "ABS with EBD", "ESP"],
      },
      {
        variant: "S-Presso LXi (O) CNG",
        // price: 461900, // ₹ 4,61,900
        engine: "998 cc",
        fuelType: "cng",
        transmission: "manual",
        mileage: 23.9, // add if you have
        seating: 5,
        features: ["Dual Airbags", "ABS with EBD", "ESP"],
      },
    ],
    banners: [
      {
        img: require("../assets/spresso/1.png"),
      },
      {
        img: require("../assets/spresso/2.webp"),
      },
      {
        img: require("../assets/spresso/3.webp"),
      },
    ],

    colors: [
      {
        name: "Solid White",
        colorCode: "#F5F5F5",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/solid_white.png?updatedAt=1762337102713",
      },
      {
        name: "Solid Sizzle Orange",
        colorCode: "#A83C0F",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/solid_sizzle_orange.png?updatedAt=1762337102693",
      },
      {
        name: "Solid Fire Red",
        colorCode: "#8E0D0F",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/solid_fire_red.png?updatedAt=1762337102684",
      },
      {
        name: "Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/bluish_black.png?updatedAt=1762337102676",
      },
      {
        name: "Metallic Granite Grey",
        colorCode: "#222526",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/metallic_granite_grey.png?updatedAt=1762337102640",
      },
      {
        name: "Metallic Silky Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/metallic_silky_silver.png?updatedAt=1762337102615",
      },
      {
        name: "Pearl Starry Blue",
        colorCode: "#114887",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/s-presso/Colors/pearl_starry_blue.png?updatedAt=1762337102162",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3565,
      },
      {
        title: "Width (mm)",
        value: 1520,
      },
      {
        title: "Height (mm)",
        value: "1553",
      },
      {
        title: "Fuel Tank(L)",
        value: 27,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "998",
      },
      {
        title: "Engine Type",
        value: "K10C",
      },
      {
        title: "Cylinders",
        value: "3",
      },
      {
        title: "Max Power",
        value: "49@5500",
      },
      {
        title: "Max Torque",
        value: "89@3500",
      },
      {
        title: "Transmission",
        value: "5MT / AGS",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilatd Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "736-775",
      },
      {
        title: "Gross Weight",
        value: "1170",
      },
    ],
  },

  // brezza
  {
    metaTitle:
      "Maruti Suzuki Brezza On Road Price Hyderabad | Brezza CNG Price | Offers on Maruti Brezza",
    metaDescription:
      "Maruti Suzuki Brezza Most Selling SUV in Hyderabad, Comest with Sunroof, 6 air bags & advanced safety features. Call now for Maruti Brezza Offers. Brezza available in Petrol & CNG Variants. Brezza CNG Price",
    id: "brezza",
    category: "arena",
    name: "Maruti Brezza",
    tag: "Step in to stand out.",
    pic: require("../assets/thumbnails/brezza.webp"),
    brochure: require("../assets/brochures/arena/brezza.pdf"),
    price: 825900,
    fuel: "Petrol / CNG",
    transmission: "5MT / 6AT",
    cc: "1462",
    variants: [{
      variant: "Brezza LXi MT ",
      price: 825900,
      engine: "1462 cc",
      fuelType: "Petrol",
      transmission: "Manual",
      mileage: 20.15,
      seating: 5,
      features: ["Bi-Halogen", "6 Airbags", "Keyless Entry System"],
    },
    {
      variant: "Brezza LXi CNG ",
      price: 916900,
      engine: "1462 cc",
      fuelType: "S-CNG",
      transmission: "Manual",
      mileage: 25.51,
      seating: 5,
      features: ["Bi-Halogen", "6 Airbags", "Keyless Entry System"],
    },
    {
      variant: "Brezza VXi MT ",
      price: 925900,
      engine: "1462 cc",
      fuelType: "Petrol",
      transmission: "Manual",
      mileage: 20.15,
      seating: 5,
      features: [
        "Bi-Halogen",
        "17.78cm (SmartPlay Studio)",
        "Auto Climate Control, +73 more",
      ],
    },
    {
      variant: "Brezza VXi CNG ",
      price: 1016900,
      engine: "1462 cc",
      fuelType: "S-CNG",
      transmission: "Manual",
      mileage: 25.51,
      seating: 5,
      features: [
        "Bi-Halogen",
        "17.78cm (SmartPlay Studio)",
        "Auto Climate Control, +69 more",
      ],
    },
    //smart hybrid
    {
      variant: "Brezza ZXi MT | Dual Tone",
      price: 1055300, // ₹ 10 55 300
      engine: "1462 cc",
      fuelType: "Smart Hybrid",
      transmission: "Manual",
      mileage: 20.15,
      seating: 5,
      features: [
        "Dual LED",
        "17.78cm (SmartPlay Studio)",
        "Auto Climate Control, +94 more",
      ],
    },
    {
      variant: "Brezza VXi AT | Metallic",
      price: 1059900, // ₹ 10 59 900
      engine: "1462 cc",
      fuelType: "Smart Hybrid",
      transmission: "Automatic",
      mileage: 19.8,
      seating: 5,
      features: [
        "Bi-Halogen",
        "17.78cm (SmartPlay Studio)",
        "Auto Climate Control, +72 more",
      ],
    },
    {
      variant: "Brezza ZXi CNG ",
      price: 1146300,
      engine: "1462 cc",
      fuelType: "S-CNG",
      transmission: "Manual",
      mileage: 25.51,
      seating: 5,
      features: [
        "Electric Sunroof",
        "17.78cm (SmartPlay Pro)",
        "Dual LED, +90 more",
      ],
    },
    {
      variant: "Brezza ZXi+ MT | Dual Tone",
      price: 1166300, // ₹ 11 66 300
      engine: "1462 cc",
      fuelType: "Smart Hybrid",
      transmission: "Manual",
      mileage: 20.15,
      seating: 5,
      features: [
        "Electric Sunroof",
        "22.86cm (SmartPlay Pro+)",
        "360 View Camera, +134 more",
      ],
    },
    {
      variant: "Brezza ZXi AT ",
      price: 1190300,
      engine: "1462 cc",
      fuelType: "Smart Hybrid",
      transmission: "Automatic",
      mileage: 19.8,
      seating: 5,
      features: [
        "Dual LED",
        "17.78cm (SmartPlay Studio)",
        "Auto Climate Control, +93 more",
      ],
    },
    {
      variant: "Brezza ZXi+ AT ",
      price: 1301300,
      engine: "1462 cc",
      fuelType: "Smart Hybrid",
      transmission: "Automatic",
      mileage: 19.8,
      seating: 5,
      features: [
        "Electric Sunroof",
        "22.86cm (SmartPlay Pro+)",
        "360 View Camera",
      ],
    },

    ],
    banners: [
      {
        img: require("../assets/brezza/1.webp"),
      },
      {
        img: require("../assets/brezza/2.webp"),
      },
      {
        img: require("../assets/brezza/3.webp"),
      },
    ],
    colors: [
      {
        name: "Sizzling Red",
        colorCode: "#B30000",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/sizzling_red-removebg-preview-min.png?updatedAt=1762412295879",
      },
      {
        name: "Metallic sizzling red + Bluish black",
        colorCode: "#B30000F",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/metallic_sizzling_red+bluish_black-removebg-preview-min.png?updatedAt=1762412295884",
      },
      {
        name: "Brave Khaki with Pearl Arctic White roof",
        colorCode: "#786F54",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/Brave_Khaki_pearl_arctic_white_roof-removebg-preview-min.png?updatedAt=1762412295828",
      },
      {
        name: "Splendid silver + Bluish black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/splendid_silver+Bluish_black-removebg-preview-min.png?updatedAt=1762412295836",
      },
      {
        name: "Splendid Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/splendid_silver-removebg-preview-min.png?updatedAt=1762412295821",
      },
      {
        name: "Pearl Arctic White",
        colorCode: "#F3F3F3",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/pearl_arctic_white-removebg-preview-min.png?updatedAt=1762412295762",
      },
      {
        name: "Magma Grey",
        colorCode: "#2B2C31",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/magma_grey-removebg-preview-min.png?updatedAt=1762412295702",
      },
      {
        name: "Brave Khakhi",
        colorCode: "#26230C",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/Brave_khakhi-removebg-preview-min.png?updatedAt=1762412295421",
      },
      {
        name: "Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/Bluish_black-removebg-preview-min.png?updatedAt=1762412295388",
      },
      {
        name: "Exuberant Blue",
        colorCode: "#355CC4",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Brezza/Colors/exuberant_blue-removebg-preview-min.png?updatedAt=1762412295359",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3995,
      },
      {
        title: "Width (mm)",
        value: 1790,
      },
      {
        title: "Height (mm)",
        value: "1685",
      },
      {
        title: "Fuel Tank(L)",
        value: 48,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "328",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1462",
      },
      {
        title: "Engine Type",
        value: "K15C Smart Hybrid",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "75.8@6000",
      },
      {
        title: "Max Torque",
        value: "136.8@3500",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilatd Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "-",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // celerio
  {
    metaTitle:
      "Maruti Suzuki Celerio On Road Price| Maruti Celerio Offers | Celerio Mileage",
    metaDescription:
      "Maruti Suzuki Celerio on road price in Hyderabad. Visit nearest Gem Maruti Suzuki Showroom to get Offers on Celerio. Maruti Suzuki Celerio Mileage. Book A Test Drive",
    id: "celerio",
    category: "arena",
    name: "Maruti Celerio",
    tag: "Drive your Style Celerio",
    pic: require("../assets/thumbnails/celerio.webp"),
    brochure: require("../assets/brochures/arena/celerio.pdf"),
    price: 469900,
    fuel: "Petrol",
    transmission: "5MT",
    cc: "998",
    variants: [
      {
        variant: "Celerio LXi MT ",
        price: 469900, // ₹ 4 69 900
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.39 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "ABS with EBD",
          "Highest Fuel Efficiency of 25.24 (km/l)",
        ],
      },
      {
        variant: "Celerio VXi MT ",
        price: 515900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.90 kmpl",
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Front & rear Power Windows"],
      },
      {
        variant: "Celerio VXi AGS ",
        price: 560900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "25.85 Kmpl",
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "Hill Hold Assist"],
      },
      {
        variant: "Celerio ZXi MT | Metallic",
        price: 570900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "26.90 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "ORVM with turn indicators",
          "Rear wiper and defogger",
        ],
      },
      {
        variant: "Celerio VXi CNG | Metallic",
        price: 597900, // ₹ 5 97 900
        engine: "998 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: "35 km/kg",
        seating: 5,
        features: [
          "6 Airbags",
          "ABS with EBD",
          "Highest Fuel Efficiency of 34.43 (km/kg)",
        ],
      },
      {
        variant: "Celerio ZXi AGS ",
        price: 615900, // ₹ 6 15 900
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "24.90 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "ORVM with turn indicators",
          "Hill Hold Assist",
        ],
      },
      {
        variant: "Celerio ZXi+ MT ",
        price: 627900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.90 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "R15 black alloy wheels",
          "Smartplay Studio with smartphone navigation",
        ],
      },
      {
        variant: "Celerio ZXi+ AGS | Metallic",
        price: 672900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "24.90 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "R15 black alloy wheels",
          "Smartplay Studio with smartphone navigation",
        ],
      },

    ],

    banners: [
      {
        img: require("../assets/celerio/1.webp"),
      },
      {
        img: require("../assets/celerio/2.webp"),
      },
      {
        img: require("../assets/celerio/3.webp"),
      },
    ],
    colors: [
      {
        name: "Metallic Speedy Blue",
        colorCode: "#1F47C2",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/metallic_speedy_blue.png?updatedAt=1762337759295",
      },
      {
        name: "Metallic Glistening Grey",
        colorCode: "#4A4A4A",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/metallic_glistening_grey.png?updatedAt=1762337758849",
      },
      {
        name: "Pearl Arctic White",
        colorCode: "#F3F3F3",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/pearl_Arctic_white.png?updatedAt=1762337759323",
      },
      {
        name: "Metallic Silky Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/metallic_silky_silver.png?updatedAt=1762337759292",
      },
      {
        name: "Solid Fire Red",
        colorCode: "#8E0D0F",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/solid_fire_red.png?updatedAt=1762337759340",
      },
      {
        name: "Pearl Caffeine Brown",
        colorCode: "#5A382E",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/pearl_caffeine_brown.png?updatedAt=1762337759336",
      },
      {
        name: "Pearl Bluish Black",
        colorCode: " #0F0F17",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/celerio/Colors/pearl_bluish_black-.png?updatedAt=1762337759335",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3695,
      },
      {
        title: "Width (mm)",
        value: 1655,
      },
      {
        title: "Height (mm)",
        value: "1555",
      },
      {
        title: "Fuel Tank(L)",
        value: 32,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "313",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "998",
      },
      {
        title: "Engine Type",
        value: "K10C",
      },
      {
        title: "Cylinders",
        value: "3",
      },
      {
        title: "Max Power",
        value: "49@5500",
      },
      {
        title: "Max Torque",
        value: "89@3500",
      },
      {
        title: "Transmission",
        value: "5MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Ventilatd Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "800-825",
      },
      {
        title: "Gross Weight",
        value: "1260",
      },
    ],
  },

  // dzire
  {
    metaTitle:
      "Maruti Suzuki Dzire Car Price Hyderabad | New Maruti Dzire Sunroof | Dzire Car Offers",
    metaDescription:
      "New Maruti Suzuki Dzire come with sunroof, Maruti dzire on road price, Swift Dzire offers in Hyderabad. Call now for more info ",
    id: "dzire",
    category: "arena",
    name: "Maruti Dzire",
    tag: "Move up to a new world of Style",
    pic: require("../assets/thumbnails/dzire.webp"),
    brochure: require("../assets/brochures/arena/dzire.pdf"),
    price: 625600,
    fuel: "Petrol / CNG",
    transmission: "5MT / 5AMT",
    cc: "1197",
    variants: [
      {
        variant: "Dzire LXi MT",
        fuelType: "Petrol",
        engine: "1197 cc",
        seating: 5,
        transmission: "manual",
        mileage: 23.9, // not shown in image
        price: 625600, // ₹ 6,25,600
        features: [
          "6 Airbags",
          "ABS with EBD and Brake Assist",
          "Dual-Tone Sophisticated Interiors",
        ],
      },
      {
        variant: "Dzire VXi MT",
        fuelType: "Petrol",
        engine: "1197 cc",
        seating: 5,
        transmission: "manual",
        mileage: 23.9, // not shown in image
        price: 717100, // ₹ 7,17,100
        features: [
          "6 Airbags",
          "ABS with EBD and Brake Assist",
          "Dual-Tone Sophisticated Interiors",
        ],
      },
      {
        variant: "Dzire VXi AMT",
        fuelType: "Petrol",
        engine: "1197 cc",
        seating: 5,
        transmission: "manual",
        mileage: 23.9,
        price: 762100,
        features: [
          "6 Airbags",
          "Hill Hold Assist",
          "Dual-Tone Sophisticated Interiors",
        ],
      },
      {
        variant: "Dzire VXi CNG",
        fuelType: "Petrol",
        engine: "1197 cc",
        seating: 5,
        transmission: "manual",
        mileage: 23.9,
        price: 803100,
        features: [
          "6 Airbags",
          "ABS with EBD and Brake Assist",
          "Dual-Tone Sophisticated Interiors",
        ],
      },
      {
        variant: "Dzire ZXi MT",
        price: 817700,
        engine: "1197 cc",
        seating: 5,
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 23.9, // km/l
        features: [
          "LED Crystal Vision",
          "Alloy Wheels",
          "Engine Push Start-Stop Button with Smart Key",
        ],
      },
      {
        variant: "Dzire ZXi AMT",
        price: 862700,
        engine: "1197 cc",
        seating: 5,
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: 23.9, // km/l
        features: [
          "LED Crystal Vision",
          "Alloy Wheels",
          "Engine Push Start-Stop Button with Smart Key",
        ],
      },
      {
        variant: "Dzire ZXi+ MT",
        price: 886300, // ₹ 8 86 300/-
        engine: "1197 cc",
        fuelType: "Petrol",
        seating: 5,
        transmission: "Manual",
        mileage: 23.9, // km/l
        features: [
          "360 View Camera (HD)",
          "Cruise Control",
          "Electric Sunroof",
        ],
      },

      {
        variant: "Dzire ZXi CNG",
        price: 903700, // ₹ 9 03 700/-
        engine: "1197 cc",
        seating: 5,
        fuelType: "CNG",
        transmission: "Manual",
        mileage: 22.9, // km/kg
        features: [
          "LED Crystal Vision",
          "Alloy Wheels",
          "Engine Push Start-Stop Button with Smart Key",
        ],
      },
      {
        variant: "Dzire ZXi+ AMT",
        price: 931300,
        engine: "1197 cc",
        fuelType: "PETROL",
        seating: 5,
        transmission: "Automatic",
        mileage: 22.9, // km/kg
        features: [
          "360 View Camera (HD)",
          "Cruise Control",
          "Electric Sunroof",
        ],
      },
    ],

    banners: [
      {
        img: require("../assets/dzire/1.webp"),
      },
      {
        img: require("../assets/dzire/2.webp"),
      },
      {
        img: require("../assets/dzire/3.webp"),
      },
    ],

    colors: [
      {
        name: "Gallant Red",
        colorCode: "#D2232B",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/gallant_red-removebg-preview-min.png?updatedAt=1762414278218",
      },
      {
        name: "Alluring Blue",
        colorCode: "#415159",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/alluring_blue-removebg-preview-min.png?updatedAt=1762414278124",
      },
      {
        name: "Nutmeg Brown",
        colorCode: "#54473C",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/Nutmeg_brown-removebg-preview-min.png?updatedAt=1762414278256",
      },
      {
        name: "Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/Bluish_black-removebg-preview-min.png?updatedAt=1762414277767",
      },
      {
        name: "Splendid Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/splendid_silver-removebg-preview-min.png?updatedAt=1762414278202",
      },
      {
        name: "Pearl Arctic White",
        colorCode: "#F3F3F3",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/pearl_arctic_white-removebg-preview-min.png?updatedAt=1762414278274",
      },
      {
        name: "Magma Grey",
        colorCode: " #2B2C31",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Dzire/Colors/magma_grey-removebg-preview-min.png?updatedAt=1762414278263",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3995,
      },
      {
        title: "Width (mm)",
        value: 1735,
      },
      {
        title: "Height (mm)",
        value: "1515",
      },
      {
        title: "Fuel Tank(L)",
        value: 37,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "378",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1197",
      },
      {
        title: "Engine Type",
        value: "1.2L K-Series Dual Jet, Dual VVT (S-CNG)",
      },
      {
        title: "Cylinders",
        value: "3",
      },
      {
        title: "Max Power",
        value: "66@6000",
      },
      {
        title: "Max Torque",
        value: "113@3500",
      },
      {
        title: "Transmission",
        value: "5MT / 5AMT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "800-915",
      },
      {
        title: "Gross Weight",
        value: "1335",
      },
    ],
  },

  // eeco
  {
    metaTitle:
      "Maruti Suzuki Eeco for Sale Hyderabad | Maruti Eeco On Road Price | Deals on Maruti Eeco",
    metaDescription:
      "Maruti Suzuki Eeco On Road Pice in Hyderabad. Eeco available in petrol & cng variants . visit nearest Gem Motors showroom for Eeco offers.",
    id: "eeco",
    category: "arena",
    name: "Maruti Eeco",
    tag: "Makes every journey special",
    pic: require("../assets/thumbnails/eeco.webp"),
    brochure: require("../assets/brochures/arena/eeco.pdf"),
    price: 578900,
    fuel: "Petrol / CNG",
    transmission: "5MT",
    cc: "1197",
    variants: [
      //ecoo
      {
        variant: "Eeco 5 Seater Standard",
        price: 520900, // ₹ 5,20,900
        engine: "1197 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 19.71, // km/l
        seating: 5,
        features: [
          "Digital Speedometer",
          "Fuel Efficiency 19.71 km/l",
          "6 Airbags",
        ],
      },
      {
        variant: "Eeco 6 Seater Standard",
        price: 547400, // ₹ 5,47,400
        engine: "1197 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 19.71, // km/l
        seating: 6,
        features: [
          "Digital Speedometer",
          "Fuel Efficiency 19.71 km/l",
          "6 Airbags",
        ],
      },
      {
        variant: "Eeco 5 Seater AC",
        price: 553800, // ₹ 5,53,800
        engine: "1197 cc",
        fuelType: "petrol",
        transmission: "manual",
        mileage: 19.71, // km/l
        seating: 5,
        features: [
          "Digital Speedometer",
          "Fuel Efficiency 19.71 km/l",
          "6 Airbags",
        ],
      },

      //petrol
      {
        variant: "Eeco 5 Seater AC CNG",
        price: 635800, // ₹ 6,35,800
        engine: "1197 cc",
        fuelType: "cng",
        transmission: "manual",
        mileage: 26.78, // km/kg
        seating: 5,
        features: [
          "Digital Speedometer",
          "Fuel Efficiency 26.78 km/kg",
          "6 Airbags",
        ],
      },
      {
        variant: "Eeco Ambulance Shell",
        price: 637100, // ₹ 6,35,800
        engine: "1197 cc",
        fuelType: "PETROL",
        transmission: "manual",
        mileage: 26.78, // km/kg
        seating: 5,
        features: [
          "3 + 1 (Patient) Seater Option",
          "Partly Frosted Rear Side Windows",
          "Space for First aid and Nursing Kit",
        ],
      },
      {
        variant: "Eeco Ambulance ",
        price: 801500,
        engine: "1197 cc",
        fuelType: "PETROL",
        transmission: "manual",
        mileage: 26.78,
        seating: 5,
        features: [
          "3 + 1 (Patient) Seater Option",
          "Partly Frosted Rear Side Windows",
          "Oxygen Cylinder Clamp",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/eeco/1.webp"),
      },
      {
        img: require("../assets/eeco/2.webp"),
      },
      {
        img: require("../assets/eeco/3.webp"),
      },
    ],
    colors: [
      {
        name: "Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Eeco/Colors/bluish_black-removebg-preview-min.png?updatedAt=1762416003912",
      },
      {
        name: "Metallic Glistening Grey",
        colorCode: "#4A4A4A",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Eeco/Colors/metallic_glisting_grey-removebg-preview-min.png?updatedAt=1762416003841",
      },
      {
        name: "Solid White",
        colorCode: "#B7B7B7",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Eeco/Colors/solid_white-removebg-preview-min.png?updatedAt=1762416003996",
      },
      {
        name: "Metallic Brisk Blue",
        colorCode: "#0D6DC3",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Eeco/Colors/metallic_brisk_blue-removebg-preview-min.png?updatedAt=1762416003920",
      },
      {
        name: "Metallic Silky Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Eeco/Colors/metallic_silky_silver-removebg-preview-min.png?updatedAt=1762416003892",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3675,
      },
      {
        title: "Width (mm)",
        value: 1475,
      },
      {
        title: "Height (mm)",
        value: "1825",
      },
      {
        title: "Fuel Tank(L)",
        value: 32,
      },
      {
        title: "Seating",
        value: 5 / 7,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1197",
      },
      {
        title: "Engine Type",
        value: "K12N",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "59.4@6000",
      },
      {
        title: "Max Torque",
        value: "104.4@3000",
      },
      {
        title: "Transmission",
        value: "5MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "935",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // ertiga
  {
    metaTitle:
      "Maruti Suzuki Ertiga On Road Price Hyderabad | Offers on Maruti Ertiga",
    metaDescription:
      "Maruti Suzuki Ertiga on road price in Hyderabad. Maruti Suzuki 7 seater car offers. Maruti Ertiga specifications & features. Book a test drive",
    id: "ertiga",
    category: "arena",
    name: "Maruti Ertiga",
    tag: "Sculpted to stand out",
    pic: require("../assets/thumbnails/ertiga.webp"),
    brochure: require("../assets/brochures/arena/ertiga.pdf"),
    price: 880000,
    fuel: "Petrol",
    transmission: "5MT / 6AT",
    cc: "1462",
    variants: [
      {
        variant: "MARUTI ERTIGA SMART HYBRID LXI 1.5L 5MT ",
        price: 880000, // ₹ 8 80 000
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 20.51,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA SMART HYBRID VXI 1.5L 5MT ",
        price: 985300, // ₹ 9 85 300
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 20.51,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA VXI CNG 1.5L 5MT ",
        price: 1076300,
        engine: "1462 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 26.11,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA SMART HYBRID ZXI 1.5L 5MT ",
        price: 1091500,
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 20.51,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA SMART HYBRID VXI 1.5L 6AT ",
        price: 1120300, // ₹ 11 20 300
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Automatic",
        mileage: 20.3,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA SMART HYBRID ZXI+ 1.5L 5MT ",
        price: 1159100, // ₹ 11 59 100
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Manual",
        mileage: 20.51,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },



      //s-cng
      {
        variant: "MARUTI ERTIGA ZXI CNG 1.5L 5MT ",
        price: 1182500, // ₹ 11 82 500
        engine: "1462 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: 26.11,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      }, {
        variant: "MARUTI ERTIGA SMART HYBRID ZXI 1.5L 6AT ",
        price: 1226500, // ₹ 12 26 500
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Automatic",
        mileage: 20.3,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
      {
        variant: "MARUTI ERTIGA SMART HYBRID ZXI+ 1.5L 6AT ",
        price: 1294100, // ₹ 12 94 100
        engine: "1462 cc",
        fuelType: "Smart Hybrid",
        transmission: "Automatic",
        mileage: 20.3,
        seating: 7,
        features: [
          "ABS with EBD and Brake Assist",
          "Premium Dual Tone Interiors",
          "Hill Hold Control",
        ],
      },
    ],

    banners: [
      {
        img: require("../assets/ertiga/1.jpg"),
      },
      {
        img: require("../assets/ertiga/2.jpg"),
      },
      {
        img: require("../assets/ertiga/3.jpg"),
      },
    ],

    colors: [
      {
        name: "Auburn Red",
        colorCode: "#732112",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/Auburn_red-removebg-preview-min.png?updatedAt=1762415003374",
      },
      {
        name: "Pearl Metallic Dignity Brown",
        colorCode: "#4A4A4A",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/pearl_metallic_diginity_brown-removebg-preview-min.png?updatedAt=1762415003754",
      },
      {
        name: "Magma Grey",
        colorCode: "#B7B7B7",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/magma_grey-removebg-preview-min.png?updatedAt=1762415003676",
      },
      {
        name: "Prime Oxford Blue",
        colorCode: "#19255A",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/prime_oxford_blue-removebg-preview-min.png?updatedAt=1762415003761",
      },
      {
        name: "Splendid Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/splendid_silver-removebg-preview-min.png?updatedAt=1762415003663",
      },
      {
        name: "Bluish Black",
        colorCode: "#18191D",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/Ertiga/Colors/bluish_black-removebg-preview-min.png?updatedAt=1762415003377",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 4395,
      },
      {
        title: "Width (mm)",
        value: 1735,
      },
      {
        title: "Height (mm)",
        value: "1690",
      },
      {
        title: "Fuel Tank(L)",
        value: 45,
      },
      {
        title: "Seating",
        value: 7,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1462",
      },
      {
        title: "Engine Type",
        value: "K15C Smart Hybrid",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "75.8@6000",
      },
      {
        title: "Max Torque",
        value: "136.8@4400",
      },
      {
        title: "Transmission",
        value: "5MT / 6AT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "1150-1205",
      },
      {
        title: "Gross Weight",
        value: "1760",
      },
    ],
  },

  // swift
  {
    metaTitle:
      "Maruti Suzuki swift On Road Price| Maruti swift Offers | swift Mileage",
    metaDescription:
      "Maruti Suzuki swift on road price in Hyderabad. Visit nearest Gem Maruti Suzuki Showroom to get Offers on swift. Maruti Suzuki swift Mileage. Book A Test Drive",
    id: "swift",
    category: "arena",
    name: "Maruti Swift",
    tag: "Too Savage, Too Stylish",
    pic: require("../assets/thumbnails/swift.webp"),
    brochure: require("../assets/brochures/arena/swift.pdf"),
    price: 599450,
    fuel: "Petrol / CNG",
    transmission: "5MT / 5AMT",
    cc: "1197",
    variants: [
      {
        variant: "LXI",
        price: 578900,
        mileage: "24.8 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "ABS with EBD",
          "Manual AC",
          "Rear Parking Sensors",
        ],
      },
      {
        variant: "VXI",
        price: 658900,
        mileage: "24.8 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "Touchscreen Infotainment",
          "Steering Mounted Controls",
          "Power Windows",
        ],
      },
      {
        variant: "VXI (O)",
        price: 684900,
        mileage: "24.8 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "Electrically Adjustable ORVMs",
          "Rear Defogger",
          "Central Locking",
        ],
      },
      {
        variant: "VXI (AMT)",
        price: 703900,
        mileage: "25.75 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic (AGS)",
        features: [
          "6 Airbags",
          "AGS Automatic Transmission",
          "Hill Hold Assist",
          "Creep Function",
        ],
      },
      {
        variant: "VXI (O) (AMT)",
        price: 729900,
        mileage: "25.75 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic (AGS)",
        features: [
          "6 Airbags",
          "AGS Automatic Transmission",
          "Hill Hold Assist",
          "Creep Function",
        ],
      },
      {
        variant: "VXI CNG 5MT",
        price: 744900,
        mileage: "25.75 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic (AGS)",
        features: [
          "6 Airbags",
          "Rear Defogger",
          "Hill Hold Assist",
          "Keyless Entry",
        ],
      },
      {
        variant: "VXI (0) CNG 5MT",
        price: 770900,
        mileage: "32.85 km/kg",
        seating: "5",
        engine: "1197 cc",
        fuelType: "PETROL + CNG",
        transmission: "Manual",
        features: [
          "Factory-fitted CNG",
          "ABS with EBD",
          "High Fuel Efficiency",
          "Rear Parking Sensors",
        ],
      },
      {
        variant: "ZXI",
        price: 752900,
        mileage: "24.8 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "LED Projector Headlamps",
          "Push Button Start",
          "Keyless Entry",
        ],
      },
      {
        variant: "ZXI AMT",
        price: 797900,
        mileage: "25.75 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "LED Projector Headlamps",
          "Push Button Start",
          "Keyless Entry",
        ],
      },

      {
        variant: "ZXI (CNG) 5MT",
        price: 838900,
        mileage: "30.9 km/kg",
        seating: "5",
        engine: "1197 cc",
        fuelType: "PETROL + CNG",
        transmission: "Manual",
        features: [
          "Factory-fitted CNG",
          "ABS with EBD",
          "Idle Start Stop",
          "High Mileage",
        ],
      },
      {
        variant: "ZXI +",
        price: 819900,
        mileage: "24.8 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: [
          "6 Airbags",
          "LED Projector Headlamps",
          "Push Button Start",
          "Keyless Entry",
        ],
      },
      {
        variant: "ZXI+ AMT ",
        price: 864900,
        mileage: "25.75 kmpl",
        seating: "5",
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic (AGS)",
        features: [
          "6 Airbags",
          "Cruise Control",
          "Hill Hold Assist",
          "Automatic Transmission",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/swift/1.webp"),
      },
      {
        img: require("../assets/swift/2.webp"),
      },
      {
        img: require("../assets/swift/3.webp"),
      },
      {
        img: require("../assets/swift/4.webp"),
      },
      {
        img: require("../assets/swift/5.webp"),
      },
      {
        img: require("../assets/swift/6.webp"),
      },
      {
        img: require("../assets/swift/7.webp"),
      },
      {
        img: require("../assets/swift/8.webp"),
      },
      {
        img: require("../assets/swift/9.webp"),
      },
    ],
    colors: [
      {
        name: "Pearl Arctic White",
        colorCode: "#D1D1D1",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-pearl-arctic-white.png",
      },
      {
        name: "Metallic Splendid Silver",
        colorCode: "#989999",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-splendid-silver.png",
      },
      {
        name: "Pearl Arctic White with Midnight Black Roof",
        colorCode: "#D6D6D6",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-pearlr-arctic-white-with-midnight-black-roof.png",
      },
      {
        name: "Pearl Metallic Midnight Blue with Black Roof",
        colorCode: "#0D3669",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-luster-blue-with-midnight-black-roof.png",
      },
      {
        name: "Sizzling Red",
        colorCode: "#A80201",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-sizzling-red.png",
      },
      {
        name: "Pearl Metallic Midnight Blue",
        colorCode: "#0D366B",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-luster-blue.png",
      },
      {
        name: "Pearl Metallic Lucent Orange",
        colorCode: "#C54618",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-luster-orange.png",
      },
      {
        name: "Metallic Magma Grey",
        colorCode: "#848481",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-magma-grey.png",
      },
      {
        name: "Solid Fire Red with Pearl Midnight Black Roof",
        colorCode: "#EA373C",
        img: "https://www.varunmaruti.com/uploads/products/colors/new-swift-sizzling-red-with-midnight-black-roof.png",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3845,
      },
      {
        title: "Width (mm)",
        value: 1735,
      },
      {
        title: "Height (mm)",
        value: "1530",
      },
      {
        title: "Fuel Tank(L)",
        value: 37,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "268",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1197",
      },
      {
        title: "Engine Type",
        value: "Advanced K series Dual Jet",
      },
      {
        title: "Cylinders",
        value: "3",
      },
      {
        title: "Max Power",
        value: "66@6000",
      },
      {
        title: "Max Torque",
        value: "89.73@6000",
      },
      {
        title: "Transmission",
        value: "5MT / 5AMT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "875-905",
      },
      {
        title: "Gross Weight",
        value: "1335",
      },
    ],
  },

  // wagnor
  {
    metaTitle:
      "Maruti Suzuki Wagnor On Road Price| Maruti Wagnor Offers | Wagnor Mileage",
    metaDescription:
      "Maruti Suzuki Wagnor on road price in Hyderabad. Visit nearest Gem Maruti Suzuki Showroom to get Offers on Wagnor. Maruti Suzuki Wagnor Mileage. Book A Test Drive",
    id: "wagonR",
    category: "arena",
    name: "Maruti WagonR",
    tag: "Strong on Looks",
    pic: require("../assets/thumbnails/wagonr.webp"),
    brochure: require("../assets/brochures/arena/wagonr.pdf"),
    price: 498900,
    fuel: "Petrol",
    transmission: "MT / AGS",
    cc: "1197",
    variants: [
      //PETROL
      {
        variant: "WagonR LXi MT ",
        price: 498900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.35 kmpl",
        seating: 5,
        features: ["6 Airbags", "ESP", "Idle Start Stop (ISS)"],
      },
      {
        variant: "WagonR VXi MT ",
        price: 551900, // ₹ 5 51 900
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.35 kmpl",
        seating: 5,
        features: ["6 Airbags", "Idle Start Stop (ISS)", "ESP"],
      },
      {
        variant: "WagonR LXi CNG ",
        price: 588900, // ₹ 5 88 900
        engine: "998 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: "24.35 kmpl",
        seating: 5,
        features: ["6 Airbags", "ESP", "Dual Tone Interiors"],
      },
      {
        variant: "WagonR ZXi MT ",
        price: 595900,
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "24.35 kmpl",
        seating: 5,
        features: ["6 Airbags", "Smart Play Dock", "Idle Start Stop (ISS)"],
      },
      {
        variant: "WagonR VXi AGS ",
        price: 596900,
        engine: "998 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "23.56 kmpl",
        seating: 5,
        features: ["6 Airbags", "Idle Start Stop (ISS)", "Hill Hold Assist"],
      },
      {
        variant: "WagonR ZXi AGS ",
        price: 640900,
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "23.56 kmpl",
        seating: 5,
        features: ["6 Airbags", "Idle Start Stop (ISS)", "Hill Hold Assist"],
      },
      {
        variant: "WagonR VXi CNG ",
        price: 641900,
        engine: "998 cc",
        fuelType: "S-CNG",
        transmission: "Manual",
        mileage: "24.35 km/kg",
        seating: 5,
        features: ["6 Airbags", "ABS with EBD", "ESP"],
      },
      {
        variant: "WagonR ZXi+ ",
        price: 649900, // ₹ 6 49 900
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        mileage: "25.24 km/kg",
        seating: 5,
        features: [
          "6 Airbags",
          "17.78 cm Smartplay Studio",
          "Idle Start Stop (ISS)",
        ],
      },

      {
        variant: "WagonR ZXi+ AGS ",
        price: 694900, // ₹ 6 94 900
        engine: "1197 cc",
        fuelType: "Petrol",
        transmission: "Automatic",
        mileage: "27.34 kmpl",
        seating: 5,
        features: [
          "6 Airbags",
          "17.78 cm Smartplay Studio",
          "Hill Hold Assist",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/wagonR/1.png"),
      },
      {
        img: require("../assets/wagonR/2.png"),
      },
      {
        img: require("../assets/wagonR/3.png"),
      },
    ],
    colors: [
      {
        name: "Solid White",
        colorCode: "#B7B7B7",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/solid_white.png?updatedAt=1762339308634",
      },
      {
        name: "Metallic Silky Silver",
        colorCode: "#737373",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/metallic_silky_silver.png?updatedAt=1762339308646",
      },
      {
        name: "Metallic Magma Grey",
        colorCode: "#2B2C31",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/metallic_magma_grey.png?updatedAt=1762339308698",
      },
      {
        name: "Pearl Metallic Gallant Red",
        colorCode: "#D2232B",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/metallic_red.png?updatedAt=1762339308679",
      },
      {
        name: "Pearl Metallic Nutmeg Brown",
        colorCode: "#54473C",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/pearl_metallic_nutmeg_brown.png?updatedAt=1762339308607",
      },
      {
        name: "Pearl Metallic Poolside Blue",
        colorCode: "#1188C5",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/poolside_blue.png?updatedAt=1762339308678",
      },
      {
        name: "Prime gallant red + Bluish black",
        colorCode: "#C2BB91",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/gallant_red_blusih_black.png?updatedAt=1762339308100",
      },
      {
        name: "Magma grey + Bluish black",
        colorCode: "#2E3032",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/magma_grey+bluish_black.png?updatedAt=1762339308688",
      },
      {
        name: "Pearl Bluish Black",
        colorCode: "#141414",
        img: "https://ik.imagekit.io/hsukyjske/Nivya-automobiles/WagonR/Colors/bluish_black.png?updatedAt=1762339308671",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3655,
      },
      {
        title: "Width (mm)",
        value: 1620,
      },
      {
        title: "Height (mm)",
        value: "1675",
      },
      {
        title: "Fuel Tank(L)",
        value: 32,
      },
      {
        title: "Seating",
        value: 5,
      },
      {
        title: "Bootspace(L)",
        value: "341",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1197",
      },
      {
        title: "Engine Type",
        value: "K12N",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "66@6000",
      },
      {
        title: "Max Torque",
        value: "113@4400",
      },
      {
        title: "Transmission",
        value: "MT / AGS",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "810-850",
      },
      {
        title: "Gross Weight",
        value: "1340",
      },
    ],
  },

  // supercarry
  {
    metaTitle:
      "Maruti Suzuki Super Carry On Road Price & Offers in Hyderabad | Maruti Suzuki Commercial Dealers",
    metaDescription:
      "Maruti Suzuki Super Carry price. Maruti Suzuki Super Carry Dealers . Super Carry is a small commercial vehicle, available in Petrol, CNG variants. It is used as a mini loading and pickup truck. It offers attractive mileage. For Offers Call Now",
    id: "super-carry",
    category: "commercial",
    name: "Super Carry",
    tag: null,
    pic: require("../assets/goods/carry.webp"),
    brochure: require("../assets/brochures/commercial/super-carry.pdf"),
    price: 506100,
    fuel: "Petrol / CNG",
    transmission: "MT",
    cc: "1196",
    variants: [
      {
        variant: "Super Carry CNG",
        price: 6.03,
        mileage: "23.24 km/kg",
        seating: "2",
        engine: "1198 cc",
        fuelType: "CNG",
        transmission: "5 MT",
        features: [
          "Factory-Fitted CNG",
          "ABS with EBD",
          "Reverse Parking Sensors",
        ],
      },
      {
        variant: "Super Carry Petrol Deckless",
        price: 4.88,
        mileage: "30 kmpl",
        seating: "2",
        engine: "1198 cc",
        fuelType: "Petrol",
        transmission: "5 MT",
        features: [
          "ABS with EBD",
          "Cabin Utility Spaces",
          "Strong Load Body (Deckless)",
        ],
      },
      {
        variant: "Super Carry Petrol",
        price: 5.03,
        mileage: "30 kmpl",
        seating: "2",
        engine: "1198 cc",
        fuelType: "Petrol",
        transmission: "5 MT",
        features: [
          "ABS with EBD",
          "Reverse Parking Sensors",
          "High Load Carrying Capability",
        ],
      },
    ],
    banners: [
      {
        img: require("../assets/carry/1.jpg"),
      },
    ],

    colors: [
      {
        name: "white ",
        colorCode: "#F7F7F7",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/supper-carry.png",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3800,
      },
      {
        title: "Width (mm)",
        value: 1562,
      },
      {
        title: "Height (mm)",
        value: "1883",
      },
      {
        title: "Fuel Tank(L)",
        value: 30,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1196",
      },
      {
        title: "Engine Type",
        value: "Advanced K-Series Dual Jet, Dual WT I",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "54@6000",
      },
      {
        title: "Max Torque",
        value: "98@3000",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "-",
      },
      {
        title: "Rear",
        value: "-",
      },
      {
        title: "Kerb",
        value: "860",
      },
      {
        title: "Gross Weight",
        value: "1600",
      },
    ],
  },

  // supercargo
  {
    metaTitle:
      "Maruti Suzuki Eeco Cargo On Road Price & Offers in Hyderabad | Eecocargo Offers",
    metaDescription:
      "Maruti Suzuki Eeco Cargo on road price inHyderabad. It’s available in Petrol, CNG variants. Maruti Suzuki Eeco Cargo Offers in Hyderabad Eeco Cargo offers good mileage, ride quality, and safety features.",
    id: "eeco-cargo",
    category: "commercial",
    name: "EECO Cargo",
    tag: null,
    pic: require("../assets/goods/cargo.webp"),
    brochure: require("../assets/brochures/commercial/cargo.pdf"),
    price: 538800,
    fuel: "Petrol / CNG",
    transmission: "MT",
    cc: "1196",
    variants: [
      {
        variant: "Eeco Cargo 1.2L 5MT",
        price: 5.39,
        mileage: "19.71 km/l",
        seating: "2",
        engine: "1196 cc",
        fuelType: "Petrol",
        transmission: "Manual",
        features: ["Dual Airbags", "ABS with EBD", "Reverse Parking Sensors"],
      },
      {
        variant: "Eeco Cargo AC CNG 1.2L 5MT",
        price: 6.71,
        mileage: "26.78 km/kg",
        seating: "2",
        engine: "1196 cc",
        fuelType: "CNG",
        transmission: "Manual",
        features: [
          "Factory-Fitted S-CNG",
          "Air Conditioner (AC)",
          "Dual Airbags + ABS with EBD",
        ],
      },
      {
        variant: "Eeco Cargo CNG 1.2L 5MT",
        price: 6.29,
        mileage: "26.78 km/kg",
        seating: "2",
        engine: "1196 cc",
        fuelType: "CNG",
        transmission: "Manual",
        features: ["Factory-Fitted S-CNG", "Dual Airbags", "ABS with EBD"],
      },
    ],
    banners: [
      {
        img: require("../assets/cargo/1.jpg"),
      },
    ],
    colors: [
      {
        name: "white ",
        colorCode: "#F7F7F7",
        img: "https://ik.imagekit.io/rahul116/ignis/colors/ecco-cargo-min.png",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 3675,
      },
      {
        title: "Width (mm)",
        value: 1475,
      },
      {
        title: "Height (mm)",
        value: "1825",
      },
      {
        title: "Fuel Tank(L)",
        value: 40,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "1196",
      },
      {
        title: "Engine Type",
        value: "G12B",
      },
      {
        title: "Cylinders",
        value: "4",
      },
      {
        title: "Max Power",
        value: "54@6000",
      },
      {
        title: "Max Torque",
        value: "98@3000",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "-",
      },
      {
        title: "Rear",
        value: "-",
      },
      {
        title: "Kerb",
        value: "920",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // v-storm
  {
    metaTitle:
      "Suzuki V-Strom SX On Road Price in Hyderabad | V Strom SX Offers",
    metaDescription:
      "Suzuki V-Strom SX On-road Price in  hyderabad.Suzuki V-Strom 250 mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki V-strom sx. ",
    id: "v-storm",
    category: "suzuki",
    name: "V-Storm SX",
    tag: null,
    pic: require("../assets/v-storm/1.png"),
    price: 213894,
    fuel: "Petrol",
    transmission: "MT",
    cc: "249",
    variants: [
      {
        variant: "V-Storm SX",
        price: 213894,
        mileage: "30 – 33 km/l",
        seating: "2",
        engine: "249cc",
        fuelType: "Petrol",
      },
    ],
    banners: [
      {
        img: require("../assets/v-storm/1.png"),
      },
      {
        img: require("../assets/v-storm/2.jpg"),
      },
      {
        img: require("../assets/v-storm/3.jpg"),
      },
    ],
    colors: [
      {
        name: "Yellow",
        colorCode: "#E9D700",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/1_620f9e8470ba0-removebg-preview-min.png",
      },
      {
        name: "Pearl-Glacier-White",
        colorCode: "#C1C0C8",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/YWW-Pearl-Glacier-White-YUA-Met-Mat-Stellar-Blue-removebg-preview-min.png",
      },
      {
        name: "Yellow",
        colorCode: "#E9D700",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/YU1-Champion-Yellow-No-2-YVB-Glass-Sparkle-Black-removebg-preview-min.png",
      },
      {
        name: "Glass-Sparkle-Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/Glass-Sparkle-Black-removebg-preview-min.png",
      },
      {
        name: "Red",
        colorCode: "#A7232D",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/Vstromsx-Met-Sonoma-Red-650X-428-Product-Roll-Image-removebg-preview-min.png",
      },
      {
        name: "Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/v-strom/VStrom_Digital_Images-2nd_Part_650x428px-15_62171c098d308-removebg-preview-min.png",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 2180,
      },
      {
        title: "Width (mm)",
        value: 880,
      },
      {
        title: "Height (mm)",
        value: "1355",
      },
      {
        title: "Fuel Tank(L)",
        value: 12,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "249",
      },
      {
        title: "Engine Type",
        value: "4-Stroke oil cooled SOHC",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "26.5@9300",
      },
      {
        title: "Max Torque",
        value: "22.2@7300",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc,Single",
      },
      {
        title: "Rear",
        value: "Disc",
      },
      {
        title: "Kerb",
        value: "167",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // sf-250
  {
    metaTitle:
      "Suzuki Gixxer SF-250 / 250 On Road Price in Hyderabad |Gixxer SF-250 Offers",
    metaDescription:
      "Suzuki Gixxer SF-250 / 250 On-road Price in hyderabad. Suzuki Gixxer SF-250 / 250 mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki Gixxer SF-250 / 250.",
    id: "s-250",
    category: "suzuki",
    name: "Gixxer SF-250 / 250",
    tag: null,
    pic: require("../assets/s-250/1.png"),
    price: 183692,
    fuel: "Petrol",
    transmission: "MT",
    cc: "249",
    variants: [
      {
        variant: "Gixxer 250 Standard Edition",
        price: 183692,
        mileage: "36 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer 250 Ride Connect Edition",
        price: 200293,
        mileage: "36 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer SF 250 Standard Edition",
        price: 194393,
        mileage: "35 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer SF 250 Ride Connect Edition",
        price: 207293,
        mileage: "35 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer SF 250 Race Edition SE",
        price: 195193,
        mileage: "35 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer SF 250 Race Ride Connect Edition",
        price: 207792,
        mileage: "35 km/l",
        seating: "2",
        engine: "249 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
    ],
    banners: [
      {
        img: require("../assets/s-250/1.png"),
      },
      {
        img: require("../assets/s-250/2.png"),
      },
    ],

    colors: [
      {
        name: "Mettalic-Matte-Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer/Mettalic-Matte-Black-SF-250-no-2-Absolute-Side-min_5f6851f4a574c.webp",
      },
      {
        name: "Mat-Black",
        colorCode: "#6F202F",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer/gixxer3-sf0250-Met-Mat-Black-No-2-Met-Mat-Bordeaux-Red-removebg-preview-min.png",
      },
      {
        name: "Blue",
        colorCode: "#0185D2",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer/1-removebg-preview-min.png",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 2010,
      },
      {
        title: "Width (mm)",
        value: 740,
      },
      {
        title: "Height (mm)",
        value: "1035",
      },
      {
        title: "Fuel Tank(L)",
        value: 12,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "249",
      },
      {
        title: "Engine Type",
        value: "4-Stroke oil cooled SOHC",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "26.5@9300",
      },
      {
        title: "Max Torque",
        value: "22.2@7300",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Disc",
      },
      {
        title: "Kerb",
        value: "161",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // sf-gixxer
  {
    metaTitle: "Suzuki Gixxer SF On Road Price in Hyderabad |Gixxer SF Offers",
    metaDescription:
      "Suzuki Gixxer SF On-road Price in hyderabad. Suzuki Gixxer SF mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki Gixxer SF.",
    id: "gixxer-sf",
    category: "suzuki",
    name: "Gixxer SF",
    tag: null,
    pic: require("../assets/sf/1.png"),
    price: 137091,
    fuel: "Petrol",
    transmission: "MT",
    cc: "155",
    variants: [
      {
        variant: "Gixxer 155 Standard Edition",
        price: 136400,
        mileage: "40 – 45 km/l",
        seating: "2",
        engine: "155 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer 155 Ride Connect Edition",
        price: 140500,
        mileage: "40 – 45 km/l",
        seating: "2",
        engine: "155 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },

      // ⭐ Gixxer SF 155 Series
      {
        variant: "Gixxer SF 155 Standard Edition",
        price: 146000,
        mileage: "40 – 45 km/l",
        seating: "2",
        engine: "155 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
      {
        variant: "Gixxer SF 155 Ride Connect Edition",
        price: 151000,
        mileage: "40 – 45 km/l",
        seating: "2",
        engine: "155 cc",
        fuelType: "Petrol",
        transmission: "Manual",
      },
    ],
    banners: [
      {
        img: require("../assets/sf/1.png"),
      },
      {
        img: require("../assets/sf/2.png"),
      },
      {
        img: require("../assets/sf/1.jpg"),
      },
    ],
    colors: [
      {
        name: "Mettalic-Matte-Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer-sx/gixxer-sf-Glass-Sparkle-Black-removebg-preview-min.png?updatedAt=1765446943146",
      },
      {
        name: "Red",
        colorCode: "#E64E4A",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer-sx/1.webp?updatedAt=1765446943074",
      },
      {
        name: "Black",
        colorCode: "#0000",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer-sx/Gixxer-SF-1111.webp?updatedAt=1765446943079",
      },
      {
        name: "Blue",
        colorCode: "#0185D2",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer-sx/Gixxer-sfMet-Triton-Blue-Pearl-Glacier-White-removebg-preview-min.png?updatedAt=1765446942539",
      },
      {
        name: "Green Grey",
        colorCode: "#BAC367",
        img: "https://ik.imagekit.io/rahul116/bikes/gixxer-sx/green-grey-sf-150-removebg-preview-min.png?updatedAt=1765446942526",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 2025,
      },
      {
        title: "Width (mm)",
        value: 715,
      },
      {
        title: "Height (mm)",
        value: "1035",
      },
      {
        title: "Fuel Tank(L)",
        value: 12,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "155",
      },
      {
        title: "Engine Type",
        value: "4-Stroke air cooled SOHC",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "13.6@8000",
      },
      {
        title: "Max Torque",
        value: "13.8@6000",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Disc",
      },
      {
        title: "Kerb",
        value: "148 / 141",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // avenis
  {
    metaTitle: "Suzuki Avenis On Road Price in Hyderabad |Avenis SF Offers",
    metaDescription:
      "Suzuki Avenis On-road Price in hyderabad. Suzuki Avenis mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki Avenis.",
    id: "avenis",
    category: "suzuki",
    name: "Avenis",
    tag: null,
    pic: require("../assets/avenis/1.jpg"),
    price: 95050,
    fuel: "Petrol",
    transmission: "MT",
    cc: "124",
    variants: [
      {
        variant: "Avenis 125 Standard Edition",
        price: 92500, // approx ex-showroom
        mileage: "45 – 50 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },

      {
        variant: "Avenis 125 Ride Connect Edition",
        price: 97000,
        mileage: "45 – 50 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
    ],
    banners: [
      {
        img: require("../assets/avenis/1.jpg"),
      },
      {
        img: require("../assets/avenis/2.jpg"),
      },
      {
        img: require("../assets/avenis/3.jpg"),
      },
    ],
    colors: [
      {
        name: "Yellow",
        colorCode: "#E9DC47",
        img: "https://ik.imagekit.io/rahul116/bikes/Avins/avenis-Champion-Yellow-No-2-GLOSSY-Sparkle-Black-min.png",
      },
      {
        name: "GLOSSY-Sparkle-Black",
        colorCode: "#B7B7B7",
        img: "https://ik.imagekit.io/rahul116/bikes/Avins/avenis-GLOSSY-Sparkle-Black.webp",
      },
      {
        name: "Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/Avins/AVENIS-Glass-Sparkle-Black-650x428-min.png",
      },
      {
        name: "Pearl-Glacier-White",
        colorCode: "#FFFFFF",
        img: "https://ik.imagekit.io/rahul116/bikes/Avins/avenis-GLOSSY-Sparkle-Black-Pearl-Glacier-White-min.png",
      },
      {
        name: "Red",
        colorCode: "#F60F17",
        img: "https://ik.imagekit.io/rahul116/bikes/Avins/1%20(2)-min.png",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 1895,
      },
      {
        title: "Width (mm)",
        value: 710,
      },
      {
        title: "Height (mm)",
        value: 1175,
      },
      {
        title: "Fuel Tank(L)",
        value: 5.2,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "124",
      },
      {
        title: "Engine Type",
        value: "4-Stroke air cooled",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "-",
      },
      {
        title: "Max Torque",
        value: "10@5500",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "106",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // access
  {
    metaTitle:
      "Suzuki Access 125 On Road Price in Hyderabad |Access 125 Mileage",
    metaDescription:
      "Suzuki Access 125 On-road Price in hyderabad. Suzuki Access 125 mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki Access 125.",
    id: "access-125",
    category: "suzuki",
    name: "Access 125",
    tag: null,
    pic: require("../assets/access/1.png"),
    price: 82192,
    fuel: "Petrol",
    transmission: "MT",
    cc: "124",
    variants: [
      {
        variant: "Access 125 Standard Edition",
        price: 82000, // approx ex-showroom
        mileage: "48 – 52 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
      {
        variant: "Access 125 Ride Connect Edition",
        price: 88000,
        mileage: "48 – 52 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
    ],
    banners: [
      {
        img: require("../assets/access/1.png"),
      },
      {
        img: require("../assets/access/2.png"),
      },
      {
        img: require("../assets/access/3.png"),
      },
    ],
    colors: [
      {
        name: "Pearl Mat Aqua Silver",
        colorCode: "#9AD8F1",
        img: "https://ik.imagekit.io/rahul116/bikes/access/Access-Blue.jpg",
      },
      {
        name: "Solid Ice Green",
        colorCode: "#7DB8AB",
        img: "https://ik.imagekit.io/rahul116/bikes/access/370-01-2025-Suzuki-Access-Website_Absolute-Side_620x428pix-02.webp",
      },
      {
        name: "Metallic Mat Stellar Blue",
        colorCode: "#263B57",
        img: "https://ik.imagekit.io/rahul116/bikes/access/370-01-2025-Suzuki-Access-Website_Absolute-Side_620x428pix-04.webp",
      },
      {
        name: "Pearl-Glacier-White",
        colorCode: "#D8D0C2",
        img: "https://ik.imagekit.io/rahul116/bikes/access/370-01-2025-Suzuki-Access-Website_Absolute-Side_620x428pix-05.webp",
      },
      {
        name: "Metallic Mat Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/access/370-01-2025-Suzuki-Access-Website_Absolute-Side_620x428pix-03.webp",
      },
    ],
    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 1870,
      },
      {
        title: "Width (mm)",
        value: 690,
      },
      {
        title: "Height (mm)",
        value: 1160,
      },
      {
        title: "Fuel Tank(L)",
        value: 5,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "124",
      },
      {
        title: "Engine Type",
        value: "4-Stroke air cooled",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "-",
      },
      {
        title: "Max Torque",
        value: "10@5500",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc/Drum",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "103/104",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  // burgman-street
  {
    metaTitle:
      "Suzuki Burgman Street On Road Price in Hyderabad |Burgman Street Offers",
    metaDescription:
      "Suzuki Burgman Street On-road Price in hyderabad. Suzuki Burgman Street mileage. Visit nearest Gem Suzuki showroom for more offers on Suzuki Burgman Street.",
    id: "burgman-street",
    category: "suzuki",
    name: "Burgman Street",
    tag: null,
    pic: require("../assets/street/1.jpg"),
    price: 96292,
    fuel: "Petrol",
    transmission: "MT",
    cc: "124",
    variants: [
      {
        variant: "Burgman Street 125 Standard Edition",
        price: 97000, // approx ex-showroom
        mileage: "45 – 50 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
      {
        variant: "Burgman Street 125 Ride Connect Edition",
        price: 103000,
        mileage: "45 – 50 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
      {
        variant: "Burgman Street 125 EX Edition",
        price: 114000,
        mileage: "45 – 48 km/l",
        seating: "2",
        engine: "124 cc",
        fuelType: "Petrol",
        transmission: "CVT Automatic",
      },
    ],
    banners: [
      {
        img: require("../assets/street/1.jpg"),
      },
      {
        img: require("../assets/street/2.jpg"),
      },
      {
        img: require("../assets/street/3.jpg"),
      },
    ],
    colors: [
      {
        name: "Green",
        colorCode: "#283932",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/1-removebg-preview-min.png?updatedAt=1765452231923",
      },
      {
        name: "Mat-Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/Matte_Black_61bc6894c8e50-removebg-preview-min.png?updatedAt=1765452232174",
      },
      {
        name: "metallic_matte_titanium_silver",
        colorCode: "#777168",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/burgman_ride_connect_metallic_matte_titanium_silver-removebg-preview-min.png?updatedAt=1765452232390",
      },
      {
        name: "Mat Blue",
        colorCode: "#587DAD",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/Matte_Blue-min_61bac3b86f02e-removebg-preview-min.png?updatedAt=1765452231759",
      },
      {
        name: "White",
        colorCode: "#FFFFFF",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/White-min_61bac3d393769-removebg-preview-min.png?updatedAt=1765452232311",
      },
      {
        name: "Black",
        colorCode: "#000000",
        img: "https://ik.imagekit.io/rahul116/bikes/Burgman/Burgman-Street-650x428pxl.webp?updatedAt=1765452231898",
      },
    ],

    // dimensions & capacity
    dimensions: [
      //max 6 items
      {
        title: "Length (mm)",
        value: 1880,
      },
      {
        title: "Width (mm)",
        value: 715,
      },
      {
        title: "Height (mm)",
        value: 1140,
      },
      {
        title: "Fuel Tank(L)",
        value: 5.5,
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "-",
      },
    ],

    //engine & transmission
    engine: [
      {
        title: "Capacity(cc)",
        value: "124",
      },
      {
        title: "Engine Type",
        value: "4-Stroke air cooled",
      },
      {
        title: "Cylinders",
        value: "-",
      },
      {
        title: "Max Power",
        value: "-",
      },
      {
        title: "Max Torque",
        value: "10@5500",
      },
      {
        title: "Transmission",
        value: "MT",
      },
    ],

    //weights & brakes
    weight: [
      {
        title: "Front",
        value: "Disc",
      },
      {
        title: "Rear",
        value: "Drum",
      },
      {
        title: "Kerb",
        value: "110",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  },

  {
    metaTitle:
      "Suzuki e-Access On Road Price in Hyderabad | Mileage, Range & Specs",
    metaDescription:
      "Suzuki e-Access electric scooter price in Hyderabad. Check range, battery, charging time and features. Visit nearest Suzuki showroom for offers.",

    id: "e-access",
    category: "suzuki",
    name: "Suzuki e-Access",
    tag: "Electric",

    pic: "https://ik.imagekit.io/rahul116/bikes/e-access/main.png",

    price: 110000, // estimated ex-showroom
    fuel: "Electric",
    transmission: "Automatic",
    cc: "-", // not applicable

    variants: [
      {
        variant: "e-Access Standard",
        price: 110000,
        range: "90 – 100 km/charge",
        seating: "2",
        battery: "3.0 kWh (est.)",
        fuelType: "Electric",
        transmission: "Automatic",
      },
      {
        variant: "e-Access Ride Connect",
        price: 120000,
        range: "90 – 100 km/charge",
        seating: "2",
        battery: "3.0 kWh (est.)",
        fuelType: "Electric",
        transmission: "Automatic",
      },
    ],

    banners: [
      {
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/1.jpg",
      },
      {
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/2.jpg",
      },
      {
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/3.jpg",
      },
    ],

    colors: [
      {
        name: "Electric Blue",
        colorCode: "#2E5AAC",
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/blue.webp",
      },
      {
        name: "Pearl White",
        colorCode: "#F2F2F2",
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/white.webp",
      },
      {
        name: "Pearl Jade Green",
        colorCode: "#698471",
        img: "https://ik.imagekit.io/rahul116/bikes/e-access/green.webp",
      },
    ],

    // dimensions & capacity
    dimensions: [
      {
        title: "Length (mm)",
        value: 1900,
      },
      {
        title: "Width (mm)",
        value: 700,
      },
      {
        title: "Height (mm)",
        value: 1150,
      },
      {
        title: "Battery Capacity",
        value: "3.0 kWh (est.)",
      },
      {
        title: "Seating",
        value: 2,
      },
      {
        title: "Bootspace(L)",
        value: "20 (est.)",
      },
    ],

    // engine / motor
    engine: [
      {
        title: "Motor Type",
        value: "BLDC Hub Motor",
      },
      {
        title: "Power",
        value: "4 kW (est.)",
      },
      {
        title: "Torque",
        value: "20 Nm (est.)",
      },
      {
        title: "Battery",
        value: "Lithium-ion",
      },
      {
        title: "Charging Time",
        value: "4 – 5 hrs",
      },
      {
        title: "Transmission",
        value: "Automatic",
      },
    ],

    // weights & brakes
    weight: [
      {
        title: "Front Brake",
        value: "Disc",
      },
      {
        title: "Rear Brake",
        value: "Drum",
      },
      {
        title: "Kerb Weight",
        value: "110 kg (est.)",
      },
      {
        title: "Gross Weight",
        value: "-",
      },
    ],
  }
];


export const mobileOffersSliders = [
  {
    img: require('../assets/mobile-banners/Gem_Web_Banners_Victoris.webp'),
    alt: 'victoris',
    link: '/vehicles/victoris',
  }, {
    img: require('../assets/mobile-banners/Gem_Web_Banners_Service.webp'),
    alt: 'book a service',
    link: '/book-a-service',
  },
  {
    img: require('../assets/mobile-banners/Gem_Web_Banners_MDS.webp'),
    alt: 'driving-scl',
    link: '/driving-school',
  },
  {
    img: require('../assets/mobile-banners/Gem_Web_Banners_Insurance.webp'),
    alt: 'insuarance',
    link: '/insurance',
  },
  {
    img: require('../assets/mobile-banners/Gem_Web_Banners_Finanace.webp'),
    alt: 'finance',
    link: '/finance',
  },

]